import { Component, OnInit, Optional, Inject, Input, Output, EventEmitter, ViewChild, Injectable, signal } from '@angular/core';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { FileService } from 'src/app/core/services/file.service';
import { ActivityService } from '../../../core/services/activity.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { UpdateOfferDetails, CheckSuitabilityDataObj } from '../../../shared/models/activity-dashboard-model';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { PersonaService } from '../../../core/services/persona.service';
import { Subject } from 'rxjs';

// import * as _ from 'lodash'
import includes from 'lodash/includes';
import trim from 'lodash/trim';
import jsPDF from 'jspdf';
import { Observable } from '../../../../../node_modules/rxjs';
import { formatDate } from '@angular/common';
import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { AssociateService } from '../../offerdb/services/associate.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { JoiningBonusPdfService } from '../../../core/services/joining-bonus-pdf.service';
import { MatDialog } from '@angular/material/dialog';

import { ResumeUploadService } from '../../../modules/hroperations/services/resume-upload.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgForm, NgModel, UntypedFormControl } from '@angular/forms';
import { startWith, map } from 'rxjs';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

export const PICK_FORMATS = {
  parse: { dateInput: { month: 'short', year: 'numeric', day: 'numeric' } },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  },
};
@Injectable()
export class PickDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: object): string {
    const format = displayFormat as unknown as string;
    if (format === 'input') {
      return formatDate(date, 'dd-MMM-yyyy', this.locale);
    } else {
      return date.toDateString();
    }
  }
}

@Component({
  selector: 'app-activity-update-offer-detail',
  templateUrl: './activity-update-offer-detail.component.html',
  styleUrls: ['./activity-update-offer-detail.component.scss'],
  providers: [
    JoiningBonusPdfService,
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
  ],
  standalone: false,
})
export class ActivityUpdateOfferDetailComponent implements OnInit {
  tempObj: any = [
    {
      jl: '',
      activityId: '',
      companyHiringTypeId: '',
      stream: null,
      unitCode: null,
    },
  ];

  ObjSmpleActs = {
    applicationIds: [],
    processID: null,
    activityID: null,
    notes: '',
  };

  tempObj_: any = [
    {
      jl: '',
      activityId: '',
      companyHiringTypeId: '',
      stream: null,
      unitCode: null,
    },
  ];

  ilObject = [
    {
      jl: '',
      activityId: '',
      companyHiringTypeId: '',
      unitCode: null,
      rolecapCode: '',
      category: null,
      joiningBonus: null,
      longTermBonus: null,
      jbpayout: null
    },
  ];

  ilObject_jb = [
    {
      jl: '',
      activityId: '',
      companyHiringTypeId: '',
      unitCode: null,
      rolecapCode: null,
      category: null,
      joiningBonus: null,
      longTermBonus: null,
      jbpayout: null
    },
  ];

  mailerObj = {
    from: '',
    to: '',
    subject: '',
    body: '',
  };

  forwardObj = [];

  launchPad = {
    candidate: [
      {
        candidateId: null,
        doj: null,
        offerStatus: '',
        posLoc: '',
        unit: '',
        activityId: null,
      },
    ],
  };

  updateOffer = {
    offerId: null,
    applicationId: null,
    doj: null,
    location: '',
    puCode: '',
  };
  private _successER = new Subject<string>();
  updateOfferDetail;
  updateODdialogbtn;
  updateOfferObj: UpdateOfferDetails;
  @Input() checkSuitabilityDataObj: CheckSuitabilityDataObj;
  @Input() candidateApplicationIds: number[];
  @Input() selectedCand;
  @Input() ifCoupled: boolean;
  @Output() childEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideDiv: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('cb') cb: MatCheckbox;

  enableBtn = false;
  loginUserName: string;
  editactivity: boolean = false;
  updateOfferForm;
  public isCollapsed: boolean = false;
  fileData: any;
  deletedFile: any;
  public ccEnable: boolean = false;
  existingFileData: any;
  companyHiringType: number = parseInt(localStorage.getItem('fresherCompHiringTypeId'));
  doj: any;
  pu: any;
  puId: any;
  toDisable: boolean = false;
  mailtrigger: boolean = false;
  location: any;
  private __warningER = new Subject<string>();
  establishment: any;
  emailArray: any = [
    { id: 'Veena_V@infosys.com', value: 'Veena' },
    { id: 'padma_kini@infosys.com', value: 'Padma' },
  ];
  remarks: any;
  ccMail: any;
  dojApproverMailId: any;
  ccUserMail: any;
  mailDetails: any;
  cityA: any = [];
  puArray: any = [];
  showBox: boolean = false;
  doj1: any;
  resObj: any;
  empId: any;
  empEmail: any;
  changedDoj: boolean = false;
  chkDoj: any;
  chkLoc: any;
  changedLoc: boolean = false;
  // toggleBtn: boolean = true;
  changedPu: boolean = false;
  jl: any;
  base_url = environment.offerTest;
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  editId: any;
  today = new Date();
  staticAlertClosed: boolean = false;
  // __warningER = new Subject<string>();
  successMessageER: string;
  warningMessageER: string;
  textArray: any;
  templateRecieved: boolean = false;
  candidateSelected: any;
  mailBody: any;
  mailSubject: any;
  canEmail: any;
  time: any;
  associateAppId: any;
  associateCanId: any;
  childToggle: boolean = false;
  estalishmentArray: any;
  establishmentChanged = false;
  chkEst: any;
  responseobj: any;
  chkPu: any;
  vendorSuccess: boolean = false;
  indentSuccess: boolean = false;
  terminateMethod: boolean = false;
  puValidate: any = true;
  locationValidate: any = true;
  ccmailvalidate: boolean = true;
  toggleBtn: boolean = false;
  showField: boolean;
  candidateId: any;
  compHiringType = +localStorage.getItem('fresherCompHiringTypeId');
  cityId: any;
  candAdress: any;
  sezAddress: any;
  stpAddress: any;
  stpAddress2: any;
  fullAddress: any;
  candidateOfferDetail: any;
  attachmentName: any;
  addressString = '';
  pu_Code: any;
  toInputValue: any;
  add_jb: any = false;
  payoutType = signal<string>('one-time');
  payoutSelected = signal<number>(1);
  joiningBonus;
  joining_bonus_fetched;
  date_: Date;
  joiningBonus_button: any = false;
  coverletterText_: any;
  dynamicPoints;
  mailBody_jb: any;
  sendBonus: any;
  il_check = false;
  count: boolean = true;
  activitiesExecuted: any[] = [];
  bpmMessage: any;
  offerStatus: string;
  addressForBonus: any;
  disableJB: boolean;
  disableW: boolean;
  jb_coverLetter: any;
  withdraw_check: any;
  jb_message;
  jb_message_true = false;
  processStage_: any;
  show: boolean = false;
  modalOption: NgbModalOptions = {};
  allRequisitions: any[] = [];
  addedRequisitions: any[] = [];
  myControl = new UntypedFormControl();
  filteredOptions: Observable<string[]>;
  request_Id;
  process_: any;
  sIB: any;
  mongoRes: any;
  subConSubCheck: boolean = false;
  educationCategory: any;

  dojError = false;
  origDOJ: any;
  previous_Doj: any;
  categories: any;
  category: any;
  chkCat: any;
  categoryChanged: boolean;
  categoryId: any;
  add_mailer: boolean = false;
  doj_remarks: any;
  dojReasonChanged: boolean = false;
  enableReason: boolean = false;
  doj_changeReason: any;
  doj_reason: any;
  specialBns = new UntypedFormControl();
  joiningBns = new UntypedFormControl();
  information_bonus_sheet: any[] = [];
  specialBonus_fetched: any;
  jb_sb_message: boolean = false;
  specialBonus_button: any = false;
  isMapFile: boolean = false;
  add_sb: boolean = false;
  disableSB: boolean;
  updated_jbSb_msg;
  specialBonus;
  jitOffer: any;
  payout: number
  dojUanCheck: boolean = false;
  offerValidationExpired: boolean = false;
  @ViewChild('emailInput') emailInput!: NgModel;
  attachmentId: any = 0;
  // hiringTypeCategory: any;
  // hiringTypeCategoryOptions: any[] = [];
  // chkHiringTypeCategory: any;
  accountName: any;
  accountNameOptions: any[] = [];
  chkAccountName: any;
  filteredAccountNames: any[] = [];
  changedAccName: boolean = false;
  // changedHiringTypeCategory: boolean = false;
  chkRemarks: string;
  remarksChanged: boolean = false;
  @ViewChild('f') updateOfferFormRef: NgForm;
  // displayHiringTypeCategory: boolean = false;
  invalidAccountName: boolean = false;
  readonly offerLetterAttachmentTypeId: number = 280;
  offlineAttachmentId9: string | null = null;
  private type9FlowInProgress: boolean = false;
  private type9WrapperFired: boolean = false;
  private type9MailerFired: boolean = false;
  joiningAddress: string;
  hideJb: boolean = false;

  constructor(
    private dialog: MatDialog,
    private http: HttpClient,
    private modalService: NgbModal,
    private jb_service: JoiningBonusPdfService,
    private associateService: AssociateService,
    @Optional() private datepipe: DatePipe,
    private personaService: PersonaService,
    private activityService: ActivityService,
    private _snackBar: MatSnackBar,
    public confirmDialog: MatDialog,
    private fileService: FileService,
    private reqService: ResumeUploadService,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.updateOfferObj = data.updateOfferObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
    }
  }

  ngOnInit() {
    this.hideJb = window['hideIBPMJB'] ? window['hideIBPMJB'] : false;
    this.isMapFile =
      (this.companyHiringType == 1 || this.companyHiringType == 4 || this.companyHiringType == 9) &&
      this.checkSuitabilityDataObj.activityId == 600103
        ? true
        : false;
    this.specialBns.valueChanges.subscribe((value) => {
      this.specialBonus = value;
      console.log(this.add_sb);
      if (value > 0) {
        this.specialBonus_button = true;
      } else {
        this.specialBonus_button = false;
      }
    });
    this.joiningBns.valueChanges.subscribe((value) => {
      this.joiningBonus = value;
      // Validate for  only positive numbers, no negative, no special chars, no alphabets
      if (this.add_jb) {
        // Check if field is empty
        if (value == null || value === '' || value === undefined) {
          this.joiningBns.setErrors({ required: true });
          this.joiningBonus_button = false;
          return;
        }
        // Check if value is numeric and positive
        const isValid = /^[0-9]+$/.test(value.toString()) && parseFloat(value) > 0;
        if (!isValid) {
          this.joiningBns.setErrors({ invalidNumber: true });
          this.joiningBonus_button = false;
          return;
        } else {
          this.joiningBns.setErrors(null);
        }
      }
      if (value > 0) {
        this.joiningBonus_button = true;
      } else {
        this.joiningBonus_button = false;
      }
    });
    this.process_ = localStorage.getItem('processName_');
    const loggedinUser = JSON.parse(localStorage.getItem('loggedInUser'));
    this.empEmail = loggedinUser.email;
    this.empId = loggedinUser.attributes.EmpNo[0];
    ////console.log("loginuser---->",this.empEmail);
    if (this.compHiringType != 1) {
      this.showField = false;
    }
    if (this.compHiringType == 1) {
      this.il_check = true;
      this.showField = true;
      this.loadAdditionalFieldsAndValues();
    }
    this.activityService.getCandidateOfferUpdate(this.candidateApplicationIds[0]).subscribe((dataFetched) => {
      // //console.log("Data", dataFetched);

      this.subConSubCheck =
        dataFetched['sourceName'] == 'SubCon Conversion' || dataFetched['sourceName'] == 'Subsidary movement'
          ? true
          : false;
      this.resObj = dataFetched;
      this.educationCategory = this.resObj.educationCategory;
      this.location = this.resObj.location;
      this.pu = this.resObj.puDescription;
      this.associateAppId = this.candidateApplicationIds[0];
      this.associateCanId = this.resObj.candidate_id;
      this.puId = this.resObj.puIds;
      this.jitOffer = this.resObj.jitOfferFlag;
       this.payout = this.resObj.jbPayoutTypee;
      this.remarks = this.compHiringType == 1 ? this.resObj.comment : '';
      this.chkRemarks = this.remarks !== null ? this.remarks : '';
      const previousDate = this.resObj.joining_date_time;
      this.previous_Doj = previousDate;
      const date = new DatePipe('en-US').transform(this.resObj.joining_date, 'dd-MMM-yyyy');
      this.doj = new Date(date);
      this.origDOJ = new DatePipe('en-US').transform(date, 'dd-MMM-yyyy');
      this.pu_Code = this.resObj.puCode;
      this.chkDoj = this.doj;
      this.chkLoc = this.location;
      this.chkPu = this.pu;
      this.canEmail = this.resObj.candidateEmail;
      this.joining_bonus_fetched = this.resObj.joiningBonus;
      this.doj_remarks = '';
      this.specialBonus_fetched = this.resObj.specialBonus;
      this.specialBonus = this.specialBonus_fetched;
       if (this.resObj.joiningBonus != null || this.resObj.uodJoiningBonus != null ) {
        const jbPayout = this.resObj.jbPayoutTypee;
        const updatedJbPayout = this.resObj.updatedJbPayoutType;
        if(this.resObj.joiningBonus != null){
          if(jbPayout === 1){
            this.jb_message = "Joining Bonus Addendum with amount INR " + this.numberWithCommas(this.resObj.joiningBonus) + " with One-Time payout has been sent to the candidate."
          }
          else if(jbPayout === 2){
            this.jb_message = "Joining Bonus Addendum with amount INR " + this.numberWithCommas(this.resObj.joiningBonus) + " with Two-Time payout has been sent to the candidate."
          }
          else{
            this.jb_message = "Joining Bonus Addendum with amount INR " + this.numberWithCommas(this.resObj.joiningBonus) + " has been sent to the candidate."
          }
          this.jb_message_true = true
        }
        if(this.resObj.uodJoiningBonus != null ){
          if(updatedJbPayout === 1){
            this.updated_jbSb_msg="Joining Bonus with amount INR " + this.numberWithCommas(this.resObj.uodJoiningBonus) + " with One-Time payout has been requested to CNB for approval."
          }
          else if(updatedJbPayout === 2){
            this.updated_jbSb_msg="Joining Bonus with amount INR " + this.numberWithCommas(this.resObj.uodJoiningBonus) + " with Two-Time payout has been requested to CNB for approval."
          }
          else{
            this.updated_jbSb_msg="Joining Bonus with amount INR " + this.numberWithCommas(this.resObj.uodJoiningBonus) + " has been requested to CNB for approval."
          }
          this.jb_sb_message = true
        }    
        this.disableSB=true
        this.onChangeSb(false)
      }
      else if(this.resObj.specialBonus!=null || this.resObj.uodSpecialBonus != null){
        if(this.resObj.specialBonus!=null){
        this.jb_message = "Special Bonus Addendum with amount INR " + this.numberWithCommas(this.resObj.specialBonus) + " has been sent to the candidate."
        this.jb_message_true = true
        }
        if (this.resObj.uodSpecialBonus != null) {
          this.updated_jbSb_msg =
            'Special Bonus with amount INR ' +
            this.numberWithCommas(this.resObj.uodSpecialBonus) +
            ' has been requested to CNB for approval.';
          this.jb_sb_message = true;
        }
        this.disableJB = true;
        this.onChange(false);
      }
      console.log('ismapfile', this.isMapFile, this.checkSuitabilityDataObj);
      // debugger
      if (this.canEmail) {
        this.toInputValue = this.canEmail;
        this.toDisable = true;
      } else {
        this.toDisable = false;
      }

      this.canEmail = this.resObj.candidateEmail;
      this.establishment = this.resObj.establishment_type;
      this.chkEst = this.establishment;
      this.estalishmentArray = this.resObj.establishmentsList;
      this.categories = this.resObj.categories;
      this.category = this.resObj.categories
        ? this.resObj.categories.find((obj) => {
            return obj.value == this.resObj.category;
          })
        : null;
      this.doj_changeReason = this.resObj.reasonOfDOJ;
      this.doj_reason = this.resObj.reasonOfDOJ
        ? this.resObj.reasonOfDOJ.find((obj) => {
            return obj.value == this.resObj.reasonOfDOJ;
          })
        : null;
      this.chkCat = this.category;
      console.log(this.category);
      this.candidateId = this.resObj.candidate_id;
      const tempLocId = this.resObj.cityId;
      this.activityService.getCityId(this.candidateApplicationIds[0], this.location).subscribe((data1) => {
        const ctid = data1.filter((citid) => citid.key == tempLocId);
        this.cityId = ctid;
        console.log(ctid, 'selected cityId');

        if (this.companyHiringType === 1 && this.cityId && this.establishment) {
          this.fetchJoiningAddress(this.cityId[0].key, this.establishment);
        }
      });
      const cid = this.resObj.candidate_id.toString();
      this.associateService.getCandidateEvents(this.candidateApplicationIds[0], cid).subscribe((a) => {
        this.activitiesExecuted = a.activityModel;
        this.candAdress = a.address;
      });
      this.associateService.getActivitiesOnCandidate(this.candidateApplicationIds[0], this.associateCanId).subscribe(
        (response) => {
          this.responseobj = response;
          ////console.log("responseobj",this.responseobj);

          if (this.responseobj.address == null) {
            // ////console.log("changedpu",this.changedPu);
            const address_snackbar = {
              msg: 'Please maintain address of the candidate',
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(address_snackbar, 'danger-snack');
            this.enableBtn = false;
          } else if (this.responseobj.address.cityName == null || this.responseobj.address.stateName == null) {
            // //console.log("changedpu",this.changedPu);
            const addresscitystate_snackbar = {
              msg: 'Please maintain city/state in address of the candidate',
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(addresscitystate_snackbar, 'danger-snack');
            this.enableBtn = false;
          }
        },
        (_err) => {
          this.enableBtn = false;
        },
      );
      let role = '';
      if (this.educationCategory == 130 || this.educationCategory == 131 || this.educationCategory == 132) {
        role = 'B-School';
      } else {
        role = this.resObj.roleCapCode;
      }
      if (this.compHiringType != 9) {
        this.activityService.fetchJoiningBonus(role).subscribe((_res) => {
          const bonusRaw = _res && _res.joiningBonus;
          if (bonusRaw == null || bonusRaw === '') {
            this.joiningBonus = 0;
          } else {
            const bonusStr = String(bonusRaw);
            this.joiningBonus = parseInt(bonusStr.replace(/\,/g, ''), 10);
          }
        });
      } else {
        this.joiningBonus = 0;
      }
    });
    this.candidateSelected = this.selectedCand[0];
    this.activityService.getAddress(this.candidateSelected.candidateId).subscribe((add) => {
      console.log(add);
      this.addressForBonus = add;
    });
  }

  openModal(content) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalService.open(content, this.modalOption);
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map((val) => (val.length >= 1 ? this.getRequistion(val) : [])),
    );
  }

  getRequistion(val: any) {
    console.log(val);
    this.allRequisitions = [];
    this.reqService.getRequisitionsforUpdateOffer(val.toLowerCase()).subscribe((data) => {
      data.forEach((item) => {
        const reqName = { id: item.req_id, value: item.req_title };
        this.allRequisitions.push(reqName);
        this.addedRequisitions.push(item);
      });
    });
    console.log(this.addedRequisitions);
    return this.allRequisitions;
  }

  forwardReq() {
    if (this.resObj.interviewLocation == null) {
      this.resObj.interviewLocation = '';
    }
    if (this.resObj.status == null) {
      this.resObj.status = '';
    }

    this.forwardObj = [
      {
        candidateId: this.candidateSelected.candidateId,
        applicationId: this.checkSuitabilityDataObj.applicationId,
        email: this.resObj.candidateEmail,
        activityId: 500301,
        name: this.resObj.fname + this.resObj.lname,
        interviewLocation: this.resObj.interviewLocation,
        source: this.resObj.source,
        skill: this.resObj.skill,
        status: this.resObj.status,
        exInfoscion: this.resObj.exInfoscion,
        matchScore: this.resObj.matchScore,
        relevantExp: this.resObj.relevantExp,
      },
    ];
    this.ngxLoader.start();

    this.activityService
      .forwardCandidate(this.process_, this.request_Id, this.compHiringType, this.forwardObj)
      .subscribe(
        (data_ret) => {
          if (data_ret.status && data_ret.status.toLowerCase() == 'failure') {
            const data_ = {
              msg: data_ret['message'],
              isSuccess: false,
            };
            this.ngxLoader.stop();
            this.activityService.openSnackBar(data_, 'danger-snack');
          } else {
            const data_ = {
              msg: data_ret['message'],
              isSuccess: true,
            };
            this.ngxLoader.stop();
            this.activityService.openSnackBar(data_, 'success-snack');
            setTimeout(() => {
              this.childEvent.emit();
            }, 1800);
          }
        },
        (_err) => {
          const data = {
            msg: 'Some Error Occurred',
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(data, 'danger-snack');
        },
      );
  }

  // -------------- <Methods used everywhere

  activityAction() {
    if (this.add_jb && (!this.joiningBonus || Number(this.joiningBonus) <= 0)) {
      this.joiningBns.setErrors({ invalidNumber: true });
      this.joiningBns.markAsTouched();
      this.activityService.openSnackBar(
        { msg: 'Joining Bonus must be greater than 0', isSuccess: false },
        'danger-snack'
      );
      return;
    }
     // Same check for Special Bonus
    if (this.add_sb && (!this.specialBonus || Number(this.specialBonus) <= 0)) {
      this.specialBns.setErrors({ invalidNumber: true });
      this.specialBns.markAsTouched();
      this.activityService.openSnackBar(
        { msg: 'Special Bonus must be greater than 0', isSuccess: false },
        'danger-snack'
      );
      return;
    }
    
    this.ngxLoader.start()
    this.changeDateFormat();
    for (const a of this.puArray) {
      if (a.value === this.pu) {
        this.puId = a.key;
      }
    }
    if (this.compHiringType == 2) {
      this.createSimpleActsObj();
      this.updateFrshrOffer();
    } else {
      if ((this.add_jb || this.add_sb) && this.isMapFile && this.companyHiringType == 1) {
        this.attachmentChk();
      } else {
        if (this.companyHiringType == 1 || this.companyHiringType == 4) {
          this.dojUanEhc();
        } else if (this.compHiringType == 9) {
          this.runType9Flow();
        } else {
          this.updateWrapper();
        }
      }
    }
  }

  private runType9Flow() {
    if (this.type9FlowInProgress) {
      return;
    }
    this.type9FlowInProgress = true;
    this.type9WrapperFired = false;
    this.type9MailerFired = false;
    if (this.offlineAttachmentId9) {
      this.updateWrapper();
      return;
    }
    this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.compHiringType, (uploadResp: any) => {
      if (!uploadResp) {
        this.ngxLoader.stop();
        this.type9FlowInProgress = false;
        return;
      }
      try {
        const parsed = typeof uploadResp === 'string' ? JSON.parse(uploadResp) : uploadResp;
        const idsMap = parsed?.ids;
        if (idsMap && Object.keys(idsMap).length > 0) {
          const entries = Object.entries(idsMap) as Array<[string, string]>;
          const offerLetterEntry = entries.find(([, name]) => name?.toLowerCase().includes('offer letter'));
          if (offerLetterEntry) {
            this.offlineAttachmentId9 = offerLetterEntry[0];
            this.updateWrapper();
          } else {
            this.ngxLoader.stop();
            this.type9FlowInProgress = false;
          }
        }
      } catch {
        this.ngxLoader.stop();
        this.type9FlowInProgress = false;
      }
    });
  }

  createSimpleActsObj() {
    this.ObjSmpleActs.activityID = this.checkSuitabilityDataObj.activityId;
    this.ObjSmpleActs.applicationIds = [];
    this.ObjSmpleActs.applicationIds.push(this.candidateApplicationIds[0]);
    this.ObjSmpleActs.processID = this.checkSuitabilityDataObj.processId;
    this.ObjSmpleActs.notes = this.remarks;
  }
  updateWrapper() {
    const sb_sent = this.add_sb ? this.specialBonus : null;
    console.log(this.specialBonus);
    let ind_;
    if (this.resObj.indentId != null) {
      ind_ = this.resObj.indentId;
    } else {
      ind_ = null;
    }
    let jb_sent;
    if (this.add_jb == true) {
      jb_sent = parseInt(this.joiningBonus);
    } else {
      jb_sent = null;
    }

    //Object for wrapper 1---->
    const wrapperObj = {
      activityId: this.checkSuitabilityDataObj.activityId,
      appCode: 'InTAP',
      applicationId: this.checkSuitabilityDataObj.applicationId,
      aprMail: 0,
      candidateID: this.candidateSelected.candidateId,
      cityId: +this.cityId[0].key,
      cityName: '',
      companyHiringTypeId: this.compHiringType,
      country: 'IN',
      dateOfJoining: this.date_.toString(),
      dojs: this.date_,
      empName: this.empEmail.split('@')[0],
      empNo: this.empId,
      empSourceCode: 'EREC',
      establishmentType: this.establishment,
      category: this.category ? this.category.value : null,
      categoryId: this.category ? this.category.key : null,
      ijpflag: 0,
      indentID: ind_,
      jobLevel: this.resObj.jobLevel.trim(),
      lastModifiedBy: this.empId,
      offerId: this.resObj.offerId,
      postingLocations: this.cityId[0].key,
      pu: this.pu,
      pucode: this.pu_Code,
      puIds: this.puId,
      recruiterID: this.empId,
      rolecapCode: this.resObj.roleCapCode,
      roleCode: this.resObj.roleCode,
      stageCode: 'REOPEN',
      stptype: 'STP',
      joiningBonus: jb_sent,
      jbPayoutType: this.payoutSelected(),
      reasonOfDOJ: this.doj_reason ? this.doj_reason.value : null,
      otherReasonsForDOJ: this.doj_reason && this.doj_reason.key == '640' ? this.doj_remarks : null,
      specialBonus: sb_sent,
      dojuanAndbgvcheck: this.dojUanCheck,
      ...(this.companyHiringType == 1 && this.offerValidationExpired && { dojApproverMailId: this.dojApproverMailId }),
      ...(this.companyHiringType == 1 && {
        // "hiringCategory": this.hiringTypeCategory || null,
        accountNameId: Number(this.accountNameOptions.find((x) => x.value === this.accountName)?.key) || null,
        comments: this.remarks || null,
      }),
    };
    console.log('---->>', wrapperObj);
    const proceedWithWrapper = () => {
      if (this.compHiringType == 9) {
        if (this.type9WrapperFired) {
          return;
        }
        this.type9WrapperFired = true;
      }
      this.activityService.updateOfferWrapper(wrapperObj).subscribe(
        (response_) => {
          console.log('response', response_);
          const check = JSON.parse(response_);
          // let check = response_
          const DOjMessage =
            'DOJ is exceed to offer validity. Please upload the attachments under DOJ validity attachment and approver mail id';
          this.bpmMessage = check['message'];
          if (this.compHiringType == 9 && check['error'] && check['error'].toLowerCase() === 'failure') {
            this.ngxLoader.stop();
            this.type9FlowInProgress = false;
            this.type9WrapperFired = false;
            this.type9MailerFired = false;
            const errorData = {
              msg: check['message'],
              isSuccess: false,
            };
            this.activityService.openSnackBar(errorData, 'danger-snack');
            return;
          }
          if (check['error'] == 'Success') {
            this.offerValidationExpired = false;
            if (this.compHiringType == 9) {
              this.checkTemplateCalled();
              return;
            }
            this.emailCheck();
            if (this.compHiringType == 1 || this.compHiringType == 4) {
              if (this.companyHiringType == 1) {
                const data = {
                  candidateId: this.resObj.candidate_id,
                  appId: this.checkSuitabilityDataObj.applicationId,
                };
                this.activityService.update_S2rlStatus(data).subscribe((res) => {
                  console.log(res);
                });
              }

              if (
                this.categoryChanged == false &&
                this.changedPu == false &&
                this.changedDoj == false &&
                this.establishmentChanged == false &&
                this.changedLoc == false &&
                this.changedAccName == false &&
                this.remarksChanged == false
              ) {
                const updateOfferDetail = {
                  applicationIds: this.candidateApplicationIds,
                  processID: this.checkSuitabilityDataObj.processId,
                  activityID: this.checkSuitabilityDataObj.activityId,
                  notes: 'Category update',
                };
                this.activityService.saveSimpleActivity(updateOfferDetail).subscribe(
                  (res: any) => {
                    if (res.error && res.error.toLowerCase() === 'failure') {
                      const data = {
                        msg: res.message,
                        isSuccess: 'error',
                      };
                      console.log(data);
                    }
                    this.childEvent.emit();
                  },
                  (_) => {
                    this.childEvent.emit();
                  },
                );
              }
              if (
                check['responseJsonList'][0]['Special bonus response:'] == 1 ||
                check['responseJsonList'][0]['Joining bonus response:'] == 1 ||
                check['responseJsonList'][0]['BPM Joining bonus response:'] == 1 ||
                this.changedPu == true ||
                this.categoryChanged == true
              ) {
                this.activityWrapper();
              } else {
                if (this.joiningBonus != null && this.add_jb == true) {
                  const res = {
                    msg: 'Unable to update Joining Bonus',
                    isSuccess: false,
                  };
                  this.ngxLoader.stop();
                  this.activityService.openSnackBar(res, 'danger-snack');
                } else {
                  this.ngxLoader.stop();
                }
              }
              if (
                this.changedAccName === true ||
                this.remarksChanged === true ||
                (this.categoryChanged &&
                  !this.changedPu &&
                  !this.changedDoj &&
                  !this.changedLoc &&
                  !this.establishmentChanged)
              ) {
                this.childEvent.emit();
              }
            }
            this.saveAttachment(this.checkSuitabilityDataObj.applicationId, this.compHiringType);
          } else if (
            check['error'] == null &&
            this.companyHiringType == 1 &&
            this.bpmMessage.trim().toLowerCase() == DOjMessage.trim().toLowerCase()
          ) {
            this.offerValidationExpired = true;
            this.ngxLoader.stop();
            const data_ = {
              msg: this.bpmMessage,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data_, 'danger-snack');
          } else {
            this.offerValidationExpired = false;
            const data_ = {
              msg: check['message'],
              isSuccess: false,
            };
            this.ngxLoader.stop();
            this.activityService.openSnackBar(data_, 'danger-snack');
          }
        },
        (_err) => {
          const data = {
            msg: 'Some Error Occurred',
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(data, 'danger-snack');
        },
      );
    };
    proceedWithWrapper();
  }
  dojUanEhc() {
    const sb_sent = this.add_sb ? this.specialBonus : null;
    console.log(this.specialBonus);
    let ind_;
    if (this.resObj.indentId != null) {
      ind_ = this.resObj.indentId;
    } else {
      ind_ = null;
    }
    let jb_sent;
    if (this.add_jb == true) {
      jb_sent = parseInt(this.joiningBonus);
    } else {
      jb_sent = null;
    }
    const jit = {
      activityId: this.checkSuitabilityDataObj.activityId,
      appCode: 'InTAP',
      applicationId: this.checkSuitabilityDataObj.applicationId,
      aprMail: 0,
      candidateID: this.candidateSelected.candidateId,
      cityId: +this.cityId[0].key,
      cityName: '',
      companyHiringTypeId: this.compHiringType,
      country: 'IN',
      dateOfJoining: this.date_.toString(),
      dojs: this.date_,
      empName: this.empEmail.split('@')[0],
      empNo: this.empId,
      empSourceCode: 'EREC',
      establishmentType: this.establishment,
      category: this.category ? this.category.value : null,
      categoryId: this.category ? this.category.key : null,
      ijpflag: 0,
      indentID: ind_,
      jobLevel: trim(this.resObj.jobLevel),
      lastModifiedBy: this.empId,
      offerId: this.resObj.offerId,
      postingLocations: this.cityId[0].key,
      pu: this.pu,
      pucode: this.pu_Code,
      puIds: this.puId,
      recruiterID: this.empId,
      rolecapCode: this.resObj.roleCapCode,
      roleCode: this.resObj.roleCode,
      stageCode: 'REOPEN',
      stptype: 'STP',
      joiningBonus: jb_sent,
      reasonOfDOJ: this.doj_reason ? this.doj_reason.value : null,
      otherReasonsForDOJ: this.doj_reason && this.doj_reason.key == '640' ? this.doj_remarks : null,
      specialBonus: sb_sent,
      dojuanAndbgvcheck: null,
    };
    let uanErrorMsg = '';
    this.activityService.jitOfferVldMsg(jit).subscribe((res) => {
      console.log(res);
      if (res.error == 'true') {
        this.ngxLoader.stop();
        this.dojUanCheck = true;
        uanErrorMsg = res.message;
        const dialogData = new ConfirmDialogModel(uanErrorMsg, '');
        const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
          maxWidth: '450px',
          data: dialogData,
        });
        dialogRef.afterClosed().subscribe((dialogResultReject) => {
          if (dialogResultReject) {
            this.ngxLoader.start();
            this.updateWrapper();
          }
        });
      } else {
        this.dojUanCheck = false;
        this.updateWrapper();
      }
    });
  }
  emailCheck() {
    if (this.compHiringType == 9) {
      return;
    }
    if (this.compHiringType == 1) {
      if (
        (this.changedPu == true || this.joiningBonus_button == true || this.specialBonus_button == true) &&
        this.changedDoj == false &&
        this.changedLoc == false &&
        this.establishmentChanged == false
      ) {
        console.log('Mail not triggered');
        this.ngxLoader.stop();
      } else {
        this.checkTemplateCalled();
      }
    } else {
      this.checkTemplateCalled();
    }
  }

  //------------ Update Offer Details -> EstablishMent, DOJ and Location

  checkTemplateCalled() {
    if (this.compHiringType == 9) {
      this.ilObject[0].jl = '3';
      this.ilObject[0].companyHiringTypeId = this.companyHiringType.toString();
      this.ilObject[0].activityId = this.checkSuitabilityDataObj.activityId.toString();
      this.ilObject[0].unitCode = null;
      this.ilObject[0].rolecapCode = null;
      this.ilObject[0].category = null;
      this.ilObject[0].joiningBonus = null;
      this.ilObject[0].longTermBonus = null;

      this.activityService.fetchTemplate(this.ilObject).subscribe(
        (data1) => {
          this.textArray = [];
          const arr: any = data1;
          const jsonArr = JSON.parse(arr);
          this.textArray = jsonArr[0].clauses[0].texts;
          this.templateRecieved = true;
          this.mailSubject = jsonArr[0].templateDescription;
          this.createCandidateData();
          this.ngxLoader.stop();
        },
        (_err) => {
          this.ngxLoader.stop();
          this.type9FlowInProgress = false;
          this.activityService.openSnackBar({ msg: 'Unable to fetch template', isSuccess: false }, 'danger-snack');
        },
      );
      return;
    }

    if (
      (this.changedDoj == true &&
        this.changedPu == false &&
        (this.changedLoc == false || this.establishmentChanged == false)) ||
      (this.changedDoj == true &&
        this.changedPu == true &&
        (this.changedLoc == false || this.establishmentChanged == false))
    ) {
      this.jl = '3';
    }
    if (
      (this.changedDoj == false &&
        this.changedPu == false &&
        (this.changedLoc == true || this.establishmentChanged == true)) ||
      (this.changedDoj == false &&
        this.changedPu == true &&
        (this.changedLoc == true || this.establishmentChanged == true))
    ) {
      this.jl = '4';
    }
    if (
      (this.changedDoj == true &&
        this.changedPu == false &&
        (this.changedLoc == true || this.establishmentChanged == true)) ||
      (this.changedDoj == true &&
        this.changedPu == true &&
        (this.changedLoc == true || this.establishmentChanged == true))
    ) {
      this.jl = '5';
    }

    if (this.jl != undefined) {
      this.count = false;
      this.ilObject[0].jl = this.jl;
      this.ilObject[0].companyHiringTypeId = this.companyHiringType.toString();
      this.ilObject[0].activityId = this.checkSuitabilityDataObj.activityId.toString();
      this.ilObject[0].rolecapCode = null;
      const address2 = this.candAdress;

      if (address2 == null) {
        const address2_msg = {
          msg: 'Please maintain address',
          isSuccess: 'error',
          duration: 5000,
        };
        this.ngxLoader.stop();
        this.activityService.openSnackBar(address2_msg, 'danger-snack');
      } else {
        this.activityService.fetchTemplate(this.ilObject).subscribe(
          (data1) => {
            this.textArray = [];
            const arr: any = data1;
            const jsonArr = JSON.parse(arr);
            this.textArray = jsonArr[0].clauses[0].texts;
            this.templateRecieved = true;
            this.mailSubject = jsonArr[0].templateDescription;
            ////console.log(this.textArray).
            // this.mailDynamicData()
            this.createCandidateData();
            this.ngxLoader.stop();
          },
          (_err) => {
            const data1 = {
              msg: 'Unable To Fetch Establishment! Try Again',
              isSuccess: false,
            };
            this.ngxLoader.stop();
            this.activityService.openSnackBar(data1, 'danger-snack');
            this.templateRecieved = false;
          },
        );
      }
    } else {
      this.ngxLoader.stop();
    }
  }

  createMailerObjManila(offlineAttachmentId?: string) {
    if (this.type9MailerFired) {
      return;
    }
    this.type9MailerFired = true;
    const date = new Date(+this.doj);
    if (date.getTimezoneOffset() < 0) {
      date.setHours(12, 0, 0);
    }
    this.offerStatus_();

    const ccList: string[] = [];
    if (this.ccMail) {
      ccList.push(this.ccMail);
    }

    const mailObj: any = {
      isMailerRequired: 'Y',
      companyHiringTypeId: 9,
      applicationId: this.checkSuitabilityDataObj.applicationId,
      activityID: this.checkSuitabilityDataObj.activityId,
      offlineAttachmentId: offlineAttachmentId,
      to: this.canEmail,
      from: 'BPMjoboffers.ph@infosys.com',
      subject: `Infosys BPM Offer of Employment – Updated Joining Date | ${this.candidateSelected.firstName} ${this.candidateSelected.lastName}`,
      body: this.mailBody || '',
      ccArray: ccList,
      bccArray: [],
      screenName: 'PH',
      files: {},
      candidateDetailsList: [
        {
          candidateId: this.candidateSelected.candidateId,
          doj: date,
          dateOfConfirmation: '',
          offerStatus: this.offerStatus,
          posLoc: this.location,
          unit: this.pu_Code,
        },
      ],
    };

    this.ngxLoader.start();
    this.activityService.sendCommunication(mailObj).subscribe(
      (res) => {
        const mailRes = JSON.parse(res);
        this.ngxLoader.stop();
        const isSuccess = mailRes['error'] === 'Success';
        if (isSuccess) {
          this.activityService.openSnackBar({ msg: mailRes['message'], isSuccess: true }, 'success-snack');
        } else {
          this.activityService.openSnackBar({ msg: mailRes['message'], isSuccess: false }, 'danger-snack');
        }
        this.childEvent.emit();
        this.type9FlowInProgress = false;
      },
      (_err) => {
        this.ngxLoader.stop();
        this.childEvent.emit();
        this.activityService.openSnackBar({ msg: 'Email not sent', isSuccess: false }, 'danger-snack');
        this.type9FlowInProgress = false;
        this.type9MailerFired = false;
        this.type9WrapperFired = false;
      },
    );
  }

  createCandidateData() {
    this.activityService.getCandidateOfferUpdate(this.candidateApplicationIds[0]).subscribe((dataFetched) => {
      const candidate: any = dataFetched;
      this.establishment = candidate.establishment_type;
      const date = new DatePipe('en-US').transform(candidate.joining_date, 'dd-MMM-yyyy');
      const joinDate = new DatePipe('en-US').transform(candidate.released_date, 'dd-MMM-yyyy');

      //test
      const rndT = this.resObj.joining_time.slice(0, -3);
      let date1;
      const amArray = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'];
      const loc1 = includes(amArray, rndT);
      if (loc1 == true) {
        date1 = this.resObj.joining_time + ' AM';
      } else {
        date1 = this.resObj.joining_time + ' PM';
      }

      //test

      const timeObj = {
        time: date1,
      };
      // timeObj.time = new DatePipe('en-US').transform(candidate.joining_date, 'mediumTime')
      Object.assign(candidate, timeObj);

      if (
        this.establishment.includes('SEZ') ||
        this.establishment.includes('SEZ2') ||
        this.establishment.includes('SEZ3') ||
        this.establishment.includes('SEZ4') ||
        this.establishment.includes('SEZ5') ||
        this.establishment.includes('SEZ6')
      ) {
        candidate.establishment_type = '(SEZ)';
      } else {
        candidate.establishment_type = '';
      }

      candidate.joining_date = date;
      candidate.released_date = joinDate;
      candidate['DD-MMM-YYYY'] = date;
      candidate.Role_Designation = candidate.roleDesignation || '';
      candidate.Location_Of_Induction = candidate.locationOfInduction || '';
      candidate.job_level = this.resObj.jobLevel ? this.resObj.jobLevel.trim() : '';
      candidate.recruiter_name = this.empEmail ? this.empEmail.split('@')[0] : '';
      this.candidateOfferDetail = candidate;
      let result;
      if (this.textArray.length > 0) {
        result = this.textArray[0].text.replace(/\$\{(.*?)\}/g, function (match, token) {
          return candidate[token] !== undefined && candidate[token] !== null ? candidate[token] : '';
        });
      }
      this.mailBody = result;
      if (this.compHiringType == 9) {
        this.createMailerObjManila(this.offlineAttachmentId9);
        return result;
      }
      this.activityService.getSezAddress(this.cityId[0].key, this.establishment).subscribe(
        (sezAddress) => {
          let addressArr: any = [];
          addressArr = sezAddress;
          this.fullAddress = [];
          for (const a of addressArr) {
            if (a.flag != 'C') {
              this.fullAddress.push(a);
            }
          }
          this.sezAddress = [];
          this.stpAddress = [];
          this.stpAddress2 = [];

          for (const a of this.fullAddress) {
            if (a.establishmentSubtype && a.establishmentSubtype.includes('SEZ')) {
              this.sezAddress.push(a);
            } else if (a.establishmentSubtype && a.establishmentSubtype.includes('STP')) {
              if (a.defaultEst) {
                this.stpAddress.push(a);
              } else {
                this.stpAddress2.push(a);
              }
            }
          }
          if (this.compHiringType == 1) {
            this.createMailerObj();
          }
          if (this.compHiringType == 4) {
            this.createMailerObjBPM();
          }
        },
        (_err) => {
          const data1 = {
            msg: 'Unable To Fetch Establishment! Try Again',
            isSuccess: false,
          };
          this.activityService.openSnackBar(data1, 'danger-snack');
        },
      );
      return result;
    });
  }

  createMailerObj() {
    if (this.templateRecieved == true) {
      // let canEmail = "vinny.batra@infosys.com"
      const senderEmail = 'offers@infosys.com';
      const ccmail2 = 'Offers_Newjoinees@infosys.com';
      const addendum = this.createAddendumPdf().output('datauristring');
      const attachmentName = this.attachmentName;
      const ccEmail = this.empEmail.split('@')[0] + '@infosys.com';
      const ccmail3 = 'India_offers@infosys.com';
      let userCCMail: any;
      // let ccdetails: any;
      if (this.ccMail) {
        userCCMail = ccEmail + ',' + this.ccMail + ',' + ccmail2 + ',' + ccmail3;
      } else {
        userCCMail = ccEmail + ',' + ccmail2 + ',' + ccmail3;
      }
      // else{
      //   userCCMail = ccEmail
      // }
      if (userCCMail && userCCMail.includes(',')) {
        userCCMail = userCCMail.split(',');
      }
      const date = new Date(+this.doj);
      const offset = date.getTimezoneOffset();
      if (offset < 0) {
        date.setHours(12, 0, 0);
      }
      this.offerStatus_();

      const mailObj = {
        isMailerRequired: 'Y',
        companyHiringTypeId: this.compHiringType,
        applicationId: this.checkSuitabilityDataObj.applicationId,
        activityID: this.checkSuitabilityDataObj.activityId,
        to: this.canEmail,
        from: senderEmail,
        subject: this.mailSubject,
        body: this.mailBody,
        ccArray: userCCMail || [ccEmail],
        bccArray: [],
        screenName: 'Lateral',
        files: {
          [attachmentName]: addendum.split(',')[1],
        },
        candidateDetailsList: [
          {
            candidateId: this.candidateSelected.candidateId,
            doj: date,
            dateOfConfirmation: '',
            offerStatus: this.offerStatus,
            posLoc: this.location,
            unit: this.pu_Code,
            // ... (this.compHiringType == 1 && {
            //   "hiringTypeCategory" : this.hiringTypeCategory || null
            // })
          },
        ],
      };
      this.ngxLoader.start();
      this.activityService.sendCommunication(mailObj).subscribe(
        (res) => {
          const mail_res = JSON.parse(res);
          this.ngxLoader.stop();
          this.childEvent.emit();
          if (mail_res['error'] === 'Success') {
            const mailTrigger_snack = {
              msg: mail_res['message'],
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(mailTrigger_snack, 'success-snack');
          } else {
            const mail_snack = {
              msg: mail_res['message'],
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(mail_snack, 'danger-snack');
          }
        },
        (_err) => {
          const data1 = {
            msg: 'Email not sent',
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(data1, 'danger-snack');
        },
      );
    }
  }

  createMailerObjBPM() {
    if (this.templateRecieved == true) {
      const months_BPM = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const newJoiningDate = new Date(this.candidateOfferDetail.joining_date);
      const revisedDOJ =
        months_BPM[newJoiningDate.getMonth()] + ' ' + newJoiningDate.getDate() + ', ' + newJoiningDate.getFullYear();
      // let canEmail = "vinny.batra@infosys.com"
      const senderEmailBPM = 'BPMOffers@infosys.com';
      const addendumBPM = this.createAddendumPdfBPM().output('datauristring');
      const attachmentNameBPM = this.attachmentName;
      const ccEmailBPM = this.empEmail.split('@')[0] + '@infosys.com';
      let userCCMailBPM: any = [];
      // let ccdetails: any;
      if (this.ccMail) {
        userCCMailBPM = ccEmailBPM + ',' + this.ccMail;
      } else {
        userCCMailBPM = ccEmailBPM;
      }
      // else{
      //   userCCMailBPM = ccEmailBPM
      // }
      if (userCCMailBPM && userCCMailBPM.includes(',')) {
        userCCMailBPM = userCCMailBPM.split(',');
      }
      const date = new Date(+this.doj);
      const offset = date.getTimezoneOffset();
      if (offset < 0) {
        date.setHours(12, 0, 0);
      }
      this.offerStatus_();

      const mailObjBPM = {
        isMailerRequired: 'Y',
        companyHiringTypeId: this.compHiringType,
        applicationId: this.checkSuitabilityDataObj.applicationId,
        activityID: this.checkSuitabilityDataObj.activityId,
        to: this.canEmail,
        from: senderEmailBPM,
        subject:
          this.mailSubject +
          revisedDOJ +
          ' - ' +
          this.candidateSelected.firstName +
          ' ' +
          this.candidateSelected.lastName +
          ' - ' +
          this.candidateSelected.candidateId,
        financialYear: this.getCurrentFinancialYear(),
        body: this.mailBody,
        ccArray: [userCCMailBPM],
        bccArray: ['BPM_HROEdockets@infosys.com', 'IBPM.OFFERLETTERS@infosys.com'],
        screenName: 'BPMOBJ',
        files: {
          [attachmentNameBPM]: addendumBPM.split(',')[1],
        },
        candidateDetailsList: [
          {
            candidateId: this.candidateSelected.candidateId,
            doj: date,
            dateOfConfirmation: '',
            offerStatus: this.offerStatus,
            posLoc: this.location,
            unit: this.pu_Code,
          },
        ],
        previousDoj: this.previous_Doj,
      };
      this.ngxLoader.start();
      this.activityService.sendCommunication(mailObjBPM).subscribe(
        (res) => {
          const mail_resBPM = JSON.parse(res);
          this.ngxLoader.stop();
          this.childEvent.emit();
          if (mail_resBPM['error'] === 'Success') {
            const mailTrigger_snackBPM = {
              msg: mail_resBPM['message'],
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(mailTrigger_snackBPM, 'success-snack');
          } else {
            const mail_snackBPM = {
              msg: mail_resBPM['message'],
              isSuccess: 'error',
              duration: 5000,
            };
            this.activityService.openSnackBar(mail_snackBPM, 'danger-snack');
          }
        },
        (_err) => {
          const dataBPM = {
            msg: 'Email not sent',
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(dataBPM, 'danger-snack');
        },
      );
    }
  }

  // ----------- Upddate Offer Details PU

  activityWrapper() {
    if (this.count == true) {
      const date = new Date(+this.doj);
      const offset = date.getTimezoneOffset();
      if (offset < 0) {
        date.setHours(12, 0, 0);
      }

      this.offerStatus_();

      const mailObj_ = {
        isMailerRequired: 'N',
        companyHiringTypeId: this.compHiringType,
        applicationId: this.checkSuitabilityDataObj.applicationId,
        activityID: this.checkSuitabilityDataObj.activityId,
        to: '',
        from: '',
        subject: '',
        body: '',
        ccArray: [''],
        bccArray: [],
        screenName: 'Lateral',
        files: {
          ['']: '',
        },
        candidateDetailsList: [
          {
            candidateId: this.candidateSelected.candidateId,
            doj: date,
            dateOfConfirmation: '',
            offerStatus: this.offerStatus,
            posLoc: this.location,
            unit: this.pu_Code,
            // ...(this.compHiringType == 1 && {
            //   "hiringTypeCategory" : this.hiringTypeCategory || null
            // })
          },
        ],
      };
      this.sendMailObj_(mailObj_);
      this.count = false;
    } else {
      if (this.add_jb == true) {
        this.joiningBonus_email();
      } else if (this.add_sb == true) {
        const spclBonus = this.information_bonus_sheet.find((bonus) => bonus.flag == 197);
        this.generateSpclDoc(spclBonus);
      } else {
        this.ngxLoader.stop();
      }
    }
  }

  private sendMailObj_(mailObj_: any) {
    this.ngxLoader.start();
    this.activityService.sendCommunication(mailObj_).subscribe(
      (obj_) => {
        const activityResponse = JSON.parse(obj_);
        if (activityResponse['error'] === 'Success') {
          const activityResponse_snack = {
            msg: activityResponse['message'],
            isSuccess: 'error',
            duration: 5000,
          };
          this.activityService.openSnackBar(activityResponse_snack, 'success-snack');
        } else {
          const activityresponse_snack = {
            msg: activityResponse['message'],
            isSuccess: 'error',
            duration: 5000,
          };
          this.activityService.openSnackBar(activityresponse_snack, 'danger-snack');
        }
        this.ngxLoader.stop();
        this.childEvent.emit();
        if (this.add_jb == true) {
          this.joiningBonus_email();
        } else if (this.add_sb == true) {
          const spclBonus = this.information_bonus_sheet.find((bonus) => bonus.flag == 197);
          this.generateSpclDoc(spclBonus);
        } else {
          this.ngxLoader.stop();
        }
      },
      (_err) => {
        this.ngxLoader.stop();
      },
    );
  }

  onClick_withdraw(event_) {
    if (!this.cb.checked && !this.disableW) {
      event_.preventDefault();
      if (confirm('Are you sure you want to Withdraw') == true) {
        this.add_jb = false;
        this.joiningBonus_button = false;
        this.disableJB = true;
        this.withdraw_check = true;
        this.activityService.withdraw(this.resObj.offerId).subscribe(
          (ret_) => {
            const data1 = {
              msg: ret_.message,
              isSuccess: false,
            };
            this.activityService.openSnackBar(data1, 'success-snack');
            setTimeout(() => {
              this.childEvent.emit();
            }, 1800);
          },
          (_err) => {
            const data1 = {
              msg: 'Unable to withdraw Joining Bonus',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data1, 'danger-snack');
          },
        );
      } else {
        this.withdraw_check = false;
      }
    } else {
      this.disableJB = false;
    }
  }
  // ----------- Joining Bonus Update

  // onChange_withdraw(event_) {

  //   if (event_.checked == true) {
  //     if (confirm("Are you sure you want to Withdraw") == true) {
  //       this.add_jb = false;
  //       this.joiningBonus_button = false
  //       this.disableJB = true;
  //       this.withdraw_check = true;
  //       this.activityService.withdraw(this.resObj.offerId).subscribe(ret_ => {
  //         let data1 = {
  //           msg: ret_.message,
  //           isSuccess: false
  //         }
  //         this.activityService.openSnackBar(data1, 'success-snack');
  //         setTimeout(() => {
  //           this.childEvent.emit()
  //         }, 1800)

  //       },
  //         err => {
  //           let data1 = {
  //             msg: "Unable to withdraw Joining Bonus",
  //             isSuccess: false
  //           }
  //           this.activityService.openSnackBar(data1, 'danger-snack');
  //         })
  //     }
  //     else {
  //       this.withdraw_check = false;
  //       console.log(this.withdraw_check)
  //       this.changeDetector.detectChanges();
  //   }
  //   }
  //   else {
  //     this.disableJB = false
  //   }
  //   this.withdraw_check = undefined;
  // }

  onChange(event_) {
    //console.log("__@@",event_)
    if (event_.checked == true) {
      this.add_jb = true;
      //this.add_mailer = true
      //this.disableW = true;
      this.onChangeSb(false);
      if (this.joiningBonus != null) {
        this.joiningBonus_button = true;
      } else {
        this.joiningBonus_button = false;
      }
      // Trigger validation when checkbox is checked
      if (!this.joiningBonus) {
        this.joiningBns.setErrors({ required: true });
        this.joiningBns.markAsTouched();
      } else {
        this.joiningBns.updateValueAndValidity();
      }
    } else {
      this.add_jb = false;
      this.joiningBonus_button = this.add_jb;
      //this.add_mailer = false
      //this.disableW = false
      // this.joiningBonus = null
      // Clear errors when checkbox is unchecked
      this.joiningBns.setErrors(null);
      this.payoutType.set('one-time');
    }
    this.enableButton();
  }

  get payoutDescription(): string {
    if (!this.joiningBonus || !this.add_jb) return '';
    const formatted = this.formatAmountShort(String(this.joiningBonus));
    const half = this.formatAmountShort(String(Number(this.joiningBonus) / 2));
    return this.payoutType() === 'one-time'
      ? `${formatted} will be paid as a One-Time Payout.`
      : `${formatted} will be paid in two installments of ${half} each as a Two-Time Payout.`;
  }

  formatAmountShort(value: string): string {
    const num = Number(value);
    if (isNaN(num)) return '';
    if (num >= 10000000) return `\u20B9${parseFloat((num / 10000000).toFixed(1))}Cr`;
    if (num >= 100000)   return `\u20B9${parseFloat((num / 100000).toFixed(1))}L`;
    if (num >= 1000)     return `\u20B9${parseFloat((num / 1000).toFixed(1))}K`;
    return `\u20B9${num}`;
  }
    onChangeMailer(event){
      this.add_mailer = (event.checked) ? true : false
    }
  onChangeSb(event_) {
    console.log('specialBonus', this.specialBonus);
    if (event_.checked == true) {
      this.onChange(false);
      this.add_sb = true;
      this.getAllDocuments();
    } else {
      this.add_sb = false;
      this.specialBonus_button = this.add_sb;
      this.enableBtn = false;
    }
    this.enableButton();
  }

  joiningBonus_email() {
    this.ilObject_jb[0].jl = this.companyHiringType == 4 ? '4' : '1';
    this.ilObject_jb[0].companyHiringTypeId = this.companyHiringType.toString();
    this.ilObject_jb[0].activityId = '600203';
    this.ilObject_jb[0].rolecapCode = null;
    this.ilObject_jb[0].jbpayout = this.payoutSelected();
    this.ngxLoader.start();
    this.activityService.fetchTemplate(this.ilObject_jb).subscribe(
      (resp__) => {
        const check_ = JSON.parse(resp__);

        let title = 'Mr';
        if (this.candidateSelected.gender == 'F' || this.candidateSelected.gender == '2') {
          title = 'Ms';
        }
        this.jb_service.fname = this.selectedCand[0].firstName;
        this.jb_service.lname = this.selectedCand[0].lastName;
        this.jb_service.joining_bonus = this.joiningBonus;
        this.jb_service.Title = title;
        this.jb_service.candidateId = this.candidateSelected.candidateId;
        this.jb_service.PresentAddressLine1 = this.addressForBonus;
        this.jb_coverLetter = check_[0].templateId;
        this.jb_service.template_ = check_[0].clauses[0].texts;
        this.jb_service.offerLetterDate = this.resObj.released_date;
        this.jb_service.doj = this.datepipe.transform(this.date_, 'MMMM dd, yyyy');
        if (this.addressForBonus.address1) {
          if (this.companyHiringType == 4) {
            this.generateJnslDoc(check_[0]).then((bonusSheet) => {
              // console.log("-----", bonusSheet)
              this.sIB = this.jb_service.siB;
              this.sendBonus = bonusSheet;
              // this.saveInDB()
              this.joiningBonusCoverletter();
            });
          } else {
            this.jb_service.generateSignOnBonusSheet(check_[0]).then((bonusSheet) => {
              // console.log("-----", bonusSheet)
              this.sendBonus = bonusSheet;
              // this.saveInDB()
              this.joiningBonusCoverletter();
            });
          }
        } else {
          const data1 = {
            msg: 'Please Maintain Data',
            isSuccess: false,
            duration: 2000,
          };
          this.activityService.openSnackBar(data1, 'danger-snack');
          this.ngxLoader.stop();
        }
        // console.log("-->", resp__)
      },
      (_err) => {
        const data1 = {
          msg: 'Joining Bonus Email Not Sent. Please Try Again',
          isSuccess: false,
          duration: 2000,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
        this.ngxLoader.stop();
      },
    );
  }

  // saveInDB() {
  //   const fd = new FormData();
  //   fd.append('objectId', this.resObj.offerId);
  //   fd.append('objectType', 'OF');
  //   fd.append('companyHiringTypeId', this.companyHiringType.toString());
  //   fd.append('attachmentId', "5");
  //   fd.append('file[' + this.sendBonus.fileName+ '.pdf]', this.sendBonus  );

  //   this.activityService.fileUpload(fd).subscribe(
  //     (res) => {
  //       let x = Object.keys(res.ids)
  //       this.mongoRes = x
  //       console.log(x)
  //       // this.ngxLoader.stop()
  //       this.joiningBonusCoverletter()
  //     },
  //     (err) => {
  //       this.__warningER.next("Something went wrong while saving attachments. Joining Bonus Not Sent")
  //       this.ngxLoader.stop()

  //    }

  //   )
  // }

  joiningBonusCoverletter() {
    this.sIB = this.add_jb ? this.jb_service.siB : this.jb_service.spclBns_sib;
    //this.activityService.getCoverLetter(tempId).subscribe(data__ => {
    // console.log("---.>>",this.selectedCand)
    // let texts_ = data__[0].clauses[0].texts[0].text
    // this.dataPoints_jb(texts_)
    const ccEmail = this.empEmail.split('@')[0] + '@infosys.com';
    const ccmail2 = 'Offers_Newjoinees@infosys.com';
    const ccmail3 = 'India_offers@infosys.com';
    let userCCMail: any;
    // let ccdetails: any;
    if (this.ccMail) {
      userCCMail = ccEmail + ',' + this.ccMail + ',' + ccmail2 + ',' + ccmail3;
    } else {
      userCCMail = ccEmail + ',' + ccmail2 + ',' + ccmail3;
    }

    if (userCCMail && userCCMail.includes(',')) {
      userCCMail = userCCMail.split(',');
    }
    const attachmentName = this.add_jb
      ? this.companyHiringType == 4
        ? 'Joining Bonus'
        : 'SignOnBonus'
      : 'Special Bonus';

    // let jb_mailObj = {
    //   "to": this.canEmail,
    //   "from": "offers@infosys.com",
    //   "subject": data__[0].templateDescription,
    //   "body": this.mailBody_jb,
    //   "ccArray": userCCMail || [ccEmail],
    //   "bccArray": [],
    //   "files": {
    //     [attachmentName]: this.sIB.split(',')[1]
    //   }
    // }
    if (this.add_jb || this.add_sb) {
      const sendBonusAttachment = {
        offerId: this.resObj.offerId,
        files: {
          [attachmentName]: this.sIB.split(',')[1],
        },
      };
      this.activityService.saveBonusAttachment(sendBonusAttachment).subscribe(
        (jb_res) => {
          console.log(jb_res);
        },
        (_err) => {
          const data1 = {
            msg: '',
            isSuccess: false,
            duration: 2000,
          };
          data1.msg = this.add_jb
            ? 'Joining Bonus Addendum Not Sent. Please Try Again'
            : 'Special Bonus Addendum Not Sent. Please Try Again';
          this.activityService.openSnackBar(data1, 'danger-snack');
          this.ngxLoader.stop();
        },
      );
    } else {
      this.ngxLoader.stop();
    }
    // let data1 = {
    //   msg: "Joining Bonus Email Sent!!",
    //   isSuccess: false,
    //   duration: 2000
    // }
    // let obj_={
    //   "attachmentId":'',
    //   "offerId":this.resObj.offerId,
    //   "applicationId":this.checkSuitabilityDataObj.applicationId,
    //   "candidateId":this.selectedCand[0].candidateId
    // }
    // this.activityService.openSnackBar(data1, 'success-snack');
    // this.activityService.sendJoiningBonusFile(obj_).subscribe(resp=>{
    //   this.childEvent.emit()
    // })
    this.ngxLoader.stop();
    // }
  }

  dataPoints_jb(text): string {
    this.createDataPoints();
    // this.clickedCandidate = true
    const candidate = this.dynamicPoints;
    const result = text.replace(/\$\{(.*?)\}/g, function (match, token) {
      return candidate[token.toLowerCase()];
    });
    // console.log("---->>>>>", result)
    this.mailBody_jb = result;
    return result;
  }

  createDataPoints() {
    // this.getFinancialYear()
    this.dynamicPoints = {
      fname: this.selectedCand[0].firstName,
      lname: this.selectedCand[0].lastName,
      released_date: this.resObj.released_date,
      candidate_id: this.selectedCand[0].candidateId,
      financial_year: this.getFinancialYear(),
    };
  }

  getFinancialYear() {
    let fiscalyear = '';
    const today = new Date();
    if (today.getMonth() + 1 <= 3) {
      fiscalyear = today.getFullYear() - 1 + '-' + today.getFullYear();
    } else {
      fiscalyear = today.getFullYear() + '-' + (today.getFullYear() + 1);
    }
    return fiscalyear;
  }

  //------------ PDF Creation

  setLogo(doc: jsPDF) {
    const base64_source =
      'data:image/png;base64,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';
    doc.addImage(base64_source, 'PNG', 450, 20, 100, 50);
  }

  getCurrentFinancialYear() {
    let fiscalyear = '';
    const today = new Date();
    if (today.getMonth() + 1 <= 3) {
      fiscalyear = (today.getFullYear() - 1 + '').slice(-2) + '-' + (today.getFullYear() + '').slice(-2);
    } else {
      fiscalyear = (today.getFullYear() + '').slice(-2) + '-' + (today.getFullYear() + 1 + '').slice(-2);
    }
    return fiscalyear;
  }

  setFooterAddress(doc) {
    let maxLenght = 0;
    let maxLenght2 = 0;
    let addressyPos = 80;
    const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;
    this.stpAddress.forEach((item) => {
      if (item.address.length > maxLenght) {
        maxLenght = item.address.length;
      }
    });
    this.sezAddress.forEach((item) => {
      if (item.address.length > maxLenght2) {
        maxLenght2 = item.address.length;
      }
    });
    if (this.establishment.includes('STP')) {
      // if STP take max lenght of stp2
      this.stpAddress2.forEach((item) => {
        if (item.address.length > maxLenght2) {
          maxLenght2 = item.address.length;
        }
      });
    }
    maxLenght = maxLenght * 4 + 65;
    maxLenght2 = maxLenght2 * 4 + 50;
    if (this.establishment.includes('SEZ')) {
      this.stpAddress.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      for (let i = this.stpAddress.length; i > 0; i--) {
        doc.text(this.stpAddress[i - 1].address, pageWidth - maxLenght, pageHeight - addressyPos);
        addressyPos += lineHeight;
      }
      if (this.sezAddress.length > 0) {
        doc.setLineWidth(1.0);
        doc.line(
          pageWidth - (maxLenght + 10),
          pageHeight - 70,
          pageWidth - (maxLenght + 10),
          pageHeight - addressyPos - 10,
        );
        addressyPos = 80;
      }
      this.sezAddress.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      for (let i = this.sezAddress.length; i > 0; i--) {
        doc.text(
          this.sezAddress[i - 1].address,
          pageWidth - (maxLenght + maxLenght2 + 10),
          pageHeight - addressyPos - 10,
        );
        addressyPos += lineHeight;
      }
      const sortedAddress = this.sezAddress.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      this.addressString = sortedAddress
        .filter((addr) => addr.flag !== 'F')
        .map((addr) => addr.address)
        .join(', ');
    } else if (this.establishment.includes('STP')) {
      this.stpAddress.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      for (let i = this.stpAddress.length; i > 0; i--) {
        doc.text(this.stpAddress[i - 1].address, pageWidth - maxLenght, pageHeight - addressyPos);
        addressyPos += lineHeight;
      }

      if (this.stpAddress2.length > 0) {
        //draw line
        doc.setLineWidth(1.0);
        doc.line(
          pageWidth - (maxLenght + 10),
          pageHeight - 70,
          pageWidth - (maxLenght + 10),
          pageHeight - addressyPos - 10,
        );
        addressyPos = 80;
      }
      this.stpAddress2 = this.stpAddress2.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      for (let i = this.stpAddress2.length; i > 0; i--) {
        doc.text(this.stpAddress2[i - 1].address, pageWidth - (maxLenght + maxLenght2 + 10), pageHeight - addressyPos);
        addressyPos += lineHeight;
      }
      const sortedAddress = this.stpAddress2.sort((a, b) => (a.sequenceNumber > b.sequenceNumber ? 1 : -1));
      this.addressString = sortedAddress
        .filter((addr) => addr.flag !== 'F')
        .map((addr) => addr.address)
        .join(', ');
    }
  }

  displayText(text): string {
    const candidate = this.candidateSelected;
    const result = text.replace(/\<\<(.*?)\>\>/g, function (match, token) {
      return candidate[token];
    });
    return result;
  }

  titleCase(str) {
    return str
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }

  createAddendumPdf() {
    const doc = new jsPDF('p', 'pt', 'a4');
    doc.setFont('times');
    doc.setFontSize(10);
    this.setLogo(doc);
    const lineHeight = doc.getLineHeight() / doc.internal.scaleFactor;

    const pageHeight = doc.internal.pageSize.getHeight();
    const pageWidth = doc.internal.pageSize.getWidth();
    const footerText = 'Company Confidential - This communication is confidential between you and Infosys Limited ';
    let yPos = 110;
    const xPos = 35;
    this.setFooterAddress(doc); //  adding footer first to get sez address

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const releaseDate = new Date(this.candidateOfferDetail.released_date);
    const formatedReleaseDate =
      months[releaseDate.getMonth()] + ' ' + releaseDate.getDate() + ', ' + releaseDate.getFullYear();

    const joiningDate = new Date(this.candidateOfferDetail.joining_date);
    const formatedjoiningDate =
      months[joiningDate.getMonth()] + ' ' + joiningDate.getDate() + ', ' + joiningDate.getFullYear();

    const dojAdd = [
      'Dear ' + this.candidateSelected.firstName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDate +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Please note that, your date of joining has been revised to ' +
        formatedjoiningDate +
        ". All the  other terms and conditions mentioned in your offer letter remain unchanged. However, all the benefits are as per Company's policies, which are subject to change from time to time.",
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'Yours sincerely, ',
    ];

    const locationAdd = [
      'Dear ' + this.candidateSelected.firstName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDate +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Please note that your Location of Posting has been changed to ' +
        this.candidateOfferDetail.location +
        ' ' +
        this.candidateOfferDetail.establishment_type +
        ', ' +
        this.addressString +
        '. All the other terms and conditions mentioned in the offer letter remain unchanged.',
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'Yours sincerely, ',
    ];

    const dojAndLocation = [
      'Dear ' + this.candidateSelected.firstName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDate +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Location of posting and date of joining Infosys have been revised as mentioned below:',
      '1. Date of joining: ' + formatedjoiningDate,
      '2. Location of posting: ' +
        this.candidateOfferDetail.location +
        ' ' +
        this.candidateOfferDetail.establishment_type +
        ', ' +
        this.addressString,
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'Yours sincerely, ',
    ];
    let pdfTxt = dojAdd;
    this.attachmentName = 'DOJAddendum.pdf';
    if (this.jl == '4') {
      pdfTxt = locationAdd;
      this.attachmentName = 'LocationAddendum.pdf';
    }
    if (this.jl == '5') {
      pdfTxt = dojAndLocation;
      this.attachmentName = 'DOJAndLocationAddendum.pdf';
    }
    doc.text('HRD/' + this.candidateSelected.candidateId + '/' + this.getCurrentFinancialYear(), xPos, yPos);
    const todayDate = new Date();
    const dateInFormat = months[todayDate.getMonth()] + ' ' + todayDate.getDate() + ', ' + todayDate.getFullYear();
    doc.text(dateInFormat, 522 - doc.getTextWidth(dateInFormat), yPos);
    yPos += lineHeight * 2;
    let title = 'Mr.';
    if (this.candidateSelected.gender == 'F' || this.candidateSelected.gender == '2') {
      title = 'Ms.';
    }
    let candidateName = this.candidateSelected.candidateName;
    if (candidateName) {
      candidateName = this.titleCase(candidateName);
    }
    const fullName = title + ' ' + candidateName;
    doc.text(fullName, xPos, yPos);
    yPos += lineHeight;
    const address = this.candAdress;
    doc.text(address.primaryAddress, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.cityName, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.stateName, xPos, yPos);
    yPos += lineHeight;
    doc.text(address.countryName, xPos, yPos);
    yPos += lineHeight * 2;
    const phoneNum = this.candidateSelected.primaryContactNo;
    // phoneNum =  phoneNum.substr(phoneNum.length - 10)
    doc.text('Ph: ' + phoneNum, xPos, yPos);
    yPos += lineHeight * 2;
    for (let i = 0; i < pdfTxt.length; i++) {
      // pdfTxt[i] = this.displayText(pdfTxt[i]);
      const splt = doc.splitTextToSize(pdfTxt[i], 480);
      const lines1 = splt.length; // splitted text is a string array
      const blockHeight = lines1 * lineHeight;
      doc.text(splt, xPos, yPos, { align: 'justify', maxWidth: 500 });
      yPos = yPos + blockHeight + lineHeight;
    }
    // commenting the Sign image as per new format
    const signImg =
      'data:image/png;base64,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';
    doc.addImage(signImg, 'PNG', 35, yPos, 80, 40);
    yPos = yPos + lineHeight + 50;
    yPos += lineHeight;
    doc.setFont('times', 'bold');
    doc.setFontSize(12);
    doc.text('Varadharaj Venkataraman', xPos, yPos);
    yPos += lineHeight;
    doc.text('SVP  - Head - Talent Acquisition – Infosys Limited', xPos, yPos);
    doc.setFont('times', 'normal');
    doc.setFontSize(10);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('I have read, accept and agree to the terms and conditions as set forth in this letter.', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('Date: ___________________________, 20____', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('_______________________________________ ', xPos, yPos);
    yPos += lineHeight;
    doc.text('Sign your name', xPos, yPos);
    yPos += lineHeight;
    yPos += lineHeight;
    doc.text('____________________ ___________________ ', xPos, yPos);
    yPos += lineHeight;
    doc.text('Print your name            Location', xPos, yPos);
    yPos += lineHeight;

    let footerPos = 20;
    doc.text('Page 1 of  1', pageWidth / 2, pageHeight - footerPos, { align: 'center' });
    footerPos += lineHeight;
    doc.setFont('times', 'italic');
    doc.text(footerText, pageWidth / 2, pageHeight - footerPos, { align: 'center' });
    doc.setFont('times', 'normal');
    this.addressString = '';
    // doc.save('add.pdf');
    return doc;
  }

  createAddendumPdfBPM() {
    const docBPM = new jsPDF('p', 'pt', 'a4');
    docBPM.setFont('times');
    docBPM.setFontSize(10);
    this.setLogo(docBPM);
    const lineHeightBPM = docBPM.getLineHeight() / docBPM.internal.scaleFactor;

    // let pageHeight = doc.internal.pageSize.getHeight();
    // let pageWidth = doc.internal.pageSize.getWidth();
    // let footerHeight = 200;
    // let footerText = "Company Confidential - This communication is confidential between you and Infosys Limited ";
    let yPosBPM = 110;
    const xPosBPM = 35;
    // this.setFooterAddress(doc); //  adding footer first to get sez address

    const monthsBPM = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    const releaseDateBPM = new Date(this.candidateOfferDetail.released_date);
    const formatedReleaseDateBPM =
      monthsBPM[releaseDateBPM.getMonth()] + ' ' + releaseDateBPM.getDate() + ', ' + releaseDateBPM.getFullYear();

    const joiningDateBPM = new Date(this.candidateOfferDetail.joining_date);
    const formatedjoiningDateBPM =
      monthsBPM[joiningDateBPM.getMonth()] + ' ' + joiningDateBPM.getDate() + ', ' + joiningDateBPM.getFullYear();

    const dojAddBPM = [
      'Dear ' + this.candidateSelected.firstName + ' ' + this.candidateSelected.lastName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDateBPM +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Please note that, your date of joining has been revised to ' +
        formatedjoiningDateBPM +
        ". All the  other terms and conditions mentioned in your offer letter remain unchanged. However, all the benefits are as per Company's policies, which are subject to change from time to time.",
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'I wish you a successful career at Infosys BPM.',
      'Yours sincerely, ',
    ];

    const locationAddBPM = [
      'Dear ' + this.candidateSelected.firstName + ' ' + this.candidateSelected.lastName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDateBPM +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Please note that your Location of Posting has been changed to ' +
        this.candidateOfferDetail.location +
        ' ' +
        this.candidateOfferDetail.establishment_type +
        ', ' +
        this.addressString +
        '. All the other terms and conditions mentioned in the offer letter remain unchanged.',
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'I wish you a successful career at Infosys BPM.',
      'Yours sincerely, ',
    ];

    const dojAndLocationBPM = [
      'Dear ' + this.candidateSelected.firstName + ' ' + this.candidateSelected.lastName + ',',
      'This is with regard to our Offer of Employment to you dated ' +
        formatedReleaseDateBPM +
        ' (Ref. No. HRD/' +
        this.candidateSelected.candidateId +
        '/' +
        this.getCurrentFinancialYear() +
        ').',
      'Location of posting and date of joining Infosys have been revised as mentioned below:',
      '1. Date of joining: ' + formatedjoiningDateBPM,
      '2. Location of posting: ' +
        this.candidateOfferDetail.location +
        ' ' +
        this.candidateOfferDetail.establishment_type +
        ', ' +
        this.addressString,
      'You are required to carry this letter with you at the time of joining the Company.',
      'As acceptance to the revision in the date of joining, please sign and return a copy of this letter to HRD at the time of your joining.',
      'I wish you a successful career at Infosys BPM.',
      'Yours sincerely, ',
    ];
    let pdfTxtBPM = dojAddBPM;
    this.attachmentName = 'DOJAddendum.pdf';
    if (this.jl == '4') {
      pdfTxtBPM = locationAddBPM;
      this.attachmentName = 'LocationAddendum.pdf';
    }
    if (this.jl == '5') {
      pdfTxtBPM = dojAndLocationBPM;
      this.attachmentName = 'DOJAndLocationAddendum.pdf';
    }
    docBPM.text('HRD/' + this.candidateSelected.candidateId + '/' + this.getCurrentFinancialYear(), xPosBPM, yPosBPM);
    const todayDateBPM = new Date();
    const dateInFormatBPM =
      monthsBPM[todayDateBPM.getMonth()] + ' ' + todayDateBPM.getDate() + ', ' + todayDateBPM.getFullYear();
    docBPM.text(dateInFormatBPM, 522 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM * 2;
    let titleBPM = 'Mr.';
    if (this.candidateSelected.gender == 'F' || this.candidateSelected.gender == '2') {
      titleBPM = 'Ms.';
    }
    let candidateNameBPM = this.candidateSelected.candidateName;
    if (candidateNameBPM) {
      candidateNameBPM = this.titleCase(candidateNameBPM);
    }
    const fullNameBPM = titleBPM + ' ' + candidateNameBPM;
    docBPM.text(fullNameBPM, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    const addressBPM = this.candAdress;
    docBPM.text(addressBPM.primaryAddress, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.text(addressBPM.cityName, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.text(addressBPM.stateName, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.text(addressBPM.countryName, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM * 2;
    const phoneNumBPM = this.candidateSelected.primaryContactNo;
    // phoneNum =  phoneNum.substr(phoneNum.length - 10)
    docBPM.text('Ph: ' + phoneNumBPM, xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM * 2;
    for (let i = 0; i < pdfTxtBPM.length; i++) {
      // pdfTxt[i] = this.displayText(pdfTxt[i]);
      const splt = docBPM.splitTextToSize(pdfTxtBPM[i], 480);
      const lines1BPM = splt.length; // splitted text is a string array
      const blockHeight = lines1BPM * lineHeightBPM;
      docBPM.text(splt, xPosBPM, yPosBPM, { align: 'justify', maxWidth: 500 });
      yPosBPM = yPosBPM + blockHeight + lineHeightBPM;
    }
    // commenting the Sign image as per new format
    const signImg =
      'data:image/png;base64,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';
    docBPM.addImage(signImg, 'PNG', 35, yPosBPM, 100, 50);
    yPosBPM = yPosBPM + lineHeightBPM + 50;
    yPosBPM += lineHeightBPM;
    docBPM.setFont('times', 'bold');
    docBPM.setFontSize(10);
    docBPM.text('Santosh Panpaliya', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFont('times', 'bold');
    docBPM.setFontSize(10);
    docBPM.text('Senior Vice President & Global Head - HRD, Infosys BPM Limited', xPosBPM, yPosBPM);
    // yPosBPM += lineHeightBPM;
    // docBPM.setFontSize(10);
    // docBPM.text('Infosys BPM Limited', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFont('times', 'normal');
    docBPM.setFontSize(10);
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.text(
      'I have read, understood and agree to the terms and conditions as set forth in this letter.',
      xPosBPM,
      yPosBPM,
    );
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.text('Date: ___________________________, 20____', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.text('_______________________________________ ', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.text('Sign your name', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.text('____________________ ___________________ ', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.text('Print your name                    Location', xPosBPM, yPosBPM);
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.setFont('times', 'bold');
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('INFOSYS BPM LIMITED', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('(Formerly Known as Infosys BPO Limited)', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('CIN: U72200KA2002PLC030310', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text(
      'Plot Nos. 26/3, 26/4 and 26/6, Electronics City Hosur',
      456 - docBPM.getTextWidth(dateInFormatBPM),
      yPosBPM,
    );
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('Road Bengaluru - 560 100, India', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('T 91 80 2852 2405', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(150);
    docBPM.text('F 91 80 2852 2411', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);
    yPosBPM += lineHeightBPM;
    yPosBPM += lineHeightBPM;
    docBPM.setFontSize(8);
    docBPM.setTextColor(135, 136, 230);
    docBPM.text('www.infosysbpm.com', 456 - docBPM.getTextWidth(dateInFormatBPM), yPosBPM);

    // doc.text("Page 1 of  1", pageWidth / 2, pageHeight - footerPos, 'center');
    docBPM.setFont('times', 'italic');
    // doc.text(footerText, pageWidth / 2, pageHeight - footerPos, 'center');
    docBPM.setFont('times', 'normal');
    this.addressString = '';
    // docBPM.save('BPMDOJ.pdf');
    return docBPM;
  }

  blobToFile(theBlob, fileName) {
    const b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.fileName = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }

  //----------------------- Validations

  ccEnableDisable() {
    //console.log(this.ccEnable);
    this.ccEnable = !this.ccEnable;
    //console.log(this.ccEnable);
  }

  getAllCities() {
    const appId = this.candidateApplicationIds[0];
    const value = this.location.trim();
    ////console.log(value, appId);
    this.cityA.splice(0, this.cityA.length);
    if (value) {
      return this.http
        .get<any>(
          this.base_url +
            '/getAllCities/Lateral/City%20Name%20Search/' +
            appId +
            '/' +
            value +
            '/null/' +
            this.companyHiringType,
        )
        .subscribe((data) => {
          ////console.log(data)
          this.cityA = data;
          this.locationValidation(value);
        });
    }
  }

  getCityId(appId, value) {
    return this.http.get<any>(
      this.base_url +
        '/getAllCities/Lateral/City%20Name%20Search/' +
        appId +
        '/' +
        value +
        '/null/' +
        this.companyHiringType,
    );
  }

  locationValidation(location) {
    if (this.cityA.length != 0) {
      const valueA = [];
      for (const c of this.cityA) {
        valueA.push(c.value);
      }
      const loc = includes(valueA, location);
      if (loc == true) {
        const tempLoc = this.cityA.find((citi) => citi.value == location);
        this.locationValidate = true;
        this.activityService.getCityId(this.candidateApplicationIds[0], location).subscribe(
          (data1) => {
            const cid = data1.filter((citid) => citid.key == tempLoc.key);
            this.cityId = cid;
            console.log(cid, 'selected cityId');
            if (this.cityId && this.cityId.length > 0) {
              this.activityService.getFilteredEstTypes(this.cityId[0].key).subscribe(
                //Filtering est type
                (filteredEst: any) => {
                  if (filteredEst && filteredEst.length > 0) {
                    this.estalishmentArray = filteredEst;
                    const currentEstValid = this.estalishmentArray.some((est) => est.value === this.establishment);
                    if (!currentEstValid) {
                      this.establishment = null;
                      this.establishmentChanged = true;
                      if (this.companyHiringType === 1) {
                        this.joiningAddress = null;
                      }
                    } else if (this.companyHiringType === 1 && this.establishment) {
                      this.fetchJoiningAddress(this.cityId[0].key, this.establishment);
                    }
                  } else {
                    this.estalishmentArray = filteredEst;
                    this.establishment = null;
                    if (this.companyHiringType === 1) {
                      this.joiningAddress = null;
                    }
                  }
                },
              );
            }
          },
          (_err) => {
            const data1 = {
              msg: 'Unable To Fetch City! Try Again',
              isSuccess: false,
            };
            // this.ngxLoader.stop();
            this.activityService.openSnackBar(data1, 'danger-snack');
          },
        );
      } else {
        this.locationValidate = false;
      }
    } else {
      this.locationValidate = false;
    }
    this.enableButton();
  }

  getAllPu() {
    const appIds = this.candidateApplicationIds[0];
    const screen = 'Lateral';
    const values = this.pu.trim();
    ////console.log(values, appIds);
    this.puArray.splice(0, this.puArray.length);
    if (values) {
      return this.http
        .get<any>(this.base_url + '/getPUAllocated/' + screen + '/' + appIds + '/' + values)
        .subscribe((data1) => {
          ////console.log(data1)

          this.puArray = data1;
          this.puValidation(values);
        });
    }
  }

  puValidation(pu) {
    if (this.puArray.length != 0) {
      const locA = [];
      for (const c of this.puArray) {
        locA.push(c.value);
      }
      const p = includes(locA, pu);
      if (p == true) {
        this.puValidate = true;
        const pu_C = pu.split(':')[0];
        this.pu_Code = pu_C;
      } else {
        this.puValidate = false;
      }
    } else {
      this.puValidate = false;
    }
    this.enableButton();
  }
  enableButton() {
    if (
      this.doj != null &&
      this.location != null &&
      this.pu != null &&
      this.establishment != null &&
      this.responseobj.address != null &&
      this.category != null &&
      this.changedAccName != null
    ) {
      if (this.puValidate == true && this.locationValidate == true && this.check()) {
        //console.log("response",this.responseobj);
        // this.responseobj
        this.enableBtn = true;
      } else if (this.showField == false && this.check()) {
        this.enableBtn = true;
      } else {
        this.enableBtn = false;
      }
    } else {
      if (this.doj != null && this.showField == false && this.check()) {
        if (this.companyHiringType == 4 && this.doj_reason.value) {
          if (this.enableReason) {
            this.enableBtn = this.enableReason && this.doj_remarks ? true : false;
          } else {
            this.enableBtn = true;
          }
        } else {
          this.enableBtn = true;
        }
      } else {
        this.enableBtn = false;
      }
    }
  }

  dateChange(a, dojContent) {
    if (a.value.toString() == this.chkDoj.toString()) {
      this.changedDoj = false;
    } else {
      this.changedDoj = true;
    }
    if (this.companyHiringType == 1) {
      const today = new DatePipe('en-US').transform(new Date(), 'dd-MMM-yyyy');
      const changedDate = new DatePipe('en-US').transform(a.value, 'dd-MMM-yyyy');
      if (this.origDOJ === today && Date.parse(changedDate) > Date.parse(this.origDOJ)) {
        this.modalOption.backdrop = 'static';
        this.modalOption.keyboard = false;
        this.modalService.open(dojContent, this.modalOption);
        console.log(this.origDOJ, today, changedDate, this.dojError);
      } else {
        this.dojError = false;
      }
    }
    this.enableButton();
  }

  dojCheck(val) {
    if (val == 'ok') {
      this.dojError = false;
    } else {
      this.dojError = true;
    }
  }

  locationChange(loc) {
    if (loc.option.value === this.chkLoc) {
      this.changedLoc = false;
    } else {
      this.changedLoc = true;
    }
    this.locationValidation(loc.option.value);
  }

  puChanged(puC) {
    if (puC.option.value === this.chkPu) {
      this.changedPu = false;
    } else {
      this.changedPu = true;
    }

    this.puValidation(puC.option.value);
  }

  changeEstablishment(est) {
    ////console.log("est", est, " + ", this.chkEst);

    if (est === this.chkEst) {
      this.establishmentChanged = false;
      ////console.log("false");
    } else {
      this.establishmentChanged = true;
      ////console.log("true");
    }
    if (this.companyHiringType === 1 && est && this.cityId && this.cityId.length > 0) {
      this.fetchJoiningAddress(this.cityId[0].key, est);
    }
    this.enableButton();
  }

  changeCategory(cat) {
    if (cat == this.chkCat) {
      this.categoryChanged = false;
    } else {
      this.categoryChanged = true;
    }
    this.enableButton();
  }

  check() {
    // console.log(this.resObj.location)
    //   if( !this.changedPu&&!this.changedLoc&&!this.changedDoj&&!this.establishmentChanged&&!this.categoryChanged && !this.changedHiringTypeCategory && !this.changedAccName){
    //     if( !this.changedPu || !this.changedLoc || !this.changedDoj || !this.establishmentChanged || !this.categoryChanged){
    //     return false
    //   }
    // }
    // else return true
    if (this.compHiringType == 1) {
      return (
        this.changedPu ||
        this.changedLoc ||
        this.changedDoj ||
        this.establishmentChanged ||
        this.categoryChanged ||
        // this.changedHiringTypeCategory ||
        this.changedAccName ||
        this.remarksChanged
      );
    } else {
      return this.changedPu || this.changedLoc || this.changedDoj || this.establishmentChanged || this.categoryChanged;
    }
  }

  //------------- Common + AAttachments

  numberWithCommas(x) {
    if (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return '';
    }
  }

  offerStatus_() {
    let loc;
    for (const act of this.activitiesExecuted) {
      if (act.activityDescription == 'Offer Accepted') {
        loc = true;
        break;
      }
    }
    if (loc == true) {
      this.offerStatus = 'Offer Accepted';
    } else {
      this.offerStatus = 'Offer Released';
    }
  }

  receiveFileOutput(filedata) {
    ////console.log("inside recievefile format");
    this.fileData = filedata['fileMerge1'];
    this.deletedFile = filedata['deletedFile1'];
    ////console.log(this.fileData);
    ////console.log(this.deletedFile);
    if (filedata) {
      if ((this.companyHiringType == 1 || this.companyHiringType == 4) && this.offerValidationExpired) {
        if (Array.isArray(this.fileData) && this.fileData.some((item) => item.attachmentId === 268)) {
          this.attachmentId = 268;
        } else {
          this.attachmentId = 0;
        }
      }
      if (this.compHiringType == 9) {
        if (Array.isArray(this.fileData) && this.fileData.some((item) => item.attachmentId === 280)) {
          this.attachmentId = 280;
        } else {
          this.attachmentId = 0;
        }
      }
    }
  }

  recieveExistingFile(filedata) {
    this.existingFileData = filedata['existingFileArray'];
    ////console.log(this.existingFileData);
  }
  saveAttachment(genericId, companyHiringTypeId, onComplete?: (res: any) => void) {
    ////console.log("inside saveattachmnt suitability")
    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {
            const data = {
              msg: 'Some error Occurred',
              isSuccess: false,
            };
            this.activityService.openSnackBar(data, 'danger-snack');
          },
        );
      });
    }
    const activityId: any = this.checkSuitabilityDataObj.activityId;
    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'AP');
    const effectiveAttachmentId = companyHiringTypeId == 9 ? '280' : '2';
    fd.append('attachmentId', effectiveAttachmentId);
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('activityId', activityId);
    let filesToUpload: any[] = Array.isArray(this.fileData) ? this.fileData : [];
    if (companyHiringTypeId == 9) {
      filesToUpload = filesToUpload.filter((it: any) => it && it.attachmentId === 280);
    }

    if (filesToUpload && filesToUpload.length > 0) {
      filesToUpload.forEach((item: any) => {
        const f: File = item && item.file ? item.file : item;
        const name: string = f && (f as any).name ? (f as any).name : 'attachment.pdf';
        fd.append('file[' + name + ']', f as any);
      });
      this.fileService.upload(fd).subscribe(
        (res) => {
          if (onComplete) {
            onComplete(res);
          }
        },
        (_err) => {
          if (onComplete) {
            onComplete(null);
          }
        },
      );
    } else {
      if (onComplete) {
        onComplete(null);
      }
    }
  }

  changeDateFormat() {
    // date = new DatePipe('en-US').transform(this.resObj.joining_date, 'dd/MM/yyyy')
    ////console.log("<date>", date);
    const date = new Date(+this.doj);
    const offset = date.getTimezoneOffset();
    if (offset < 0) {
      date.setHours(12, 0, 0);
    }
    this.date_ = date;
  }

  destroyCard() {
    this.hideDiv.emit();
  }

  actvityWrapBPM() {
    // if (this.count == true) {

    const date = new Date(+this.doj);
    const offset = date.getTimezoneOffset();
    if (offset < 0) {
      date.setHours(12, 0, 0);
    }

    this.offerStatus_();

    const mailObj_ = {
      isMailerRequired: 'N',
      companyHiringTypeId: this.compHiringType,
      applicationId: this.checkSuitabilityDataObj.applicationId,
      activityID: this.checkSuitabilityDataObj.activityId,
      to: this.canEmail,
      from: '',
      subject: '',
      body: '',
      ccArray: [''],
      bccArray: [],
      screenName: 'BPM',
      files: {
        ['']: '',
      },
      candidateDetailsList: [
        {
          candidateId: this.candidateSelected.candidateId,
          doj: date,
          dateOfConfirmation: '',
          offerStatus: this.offerStatus,
          posLoc: this.location,
          unit: this.pu_Code,
        },
      ],
    };
    this.count = false;

    this.activityService.sendCommunication(mailObj_).subscribe(
      (obj_) => {
        const res = JSON.parse(obj_);
        if (res['error'] == 'Success') {
          const data = {
            msg: res['message'],
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(data, 'success-snack');
        } else {
          const data = {
            msg: res['message'],
            isSuccess: false,
          };
          this.ngxLoader.stop();
          this.activityService.openSnackBar(data, 'danger-snack');
        }
      },
      (_err) => {
        const data = {
          msg: 'Something went wrong!',
          isSuccess: false,
        };
        this.ngxLoader.stop();
        this.activityService.openSnackBar(data, 'danger-snack');
      },
    );

    // }
    // else {}
  }

  updateFrshrOffer() {
    this.activityService.saveSimpleActivity(this.ObjSmpleActs).subscribe(
      (res: any) => {
        console.log(res);
        if (res.error && res.error.toLowerCase() === 'failure') {
          this.ngxLoader.stop();
          const data = {
            msg: res.message,
            isSuccess: 'error',
          };
          this.activityService.openSnackBar(data, 'danger-snack');
        } else {
          const aid = this.candidateApplicationIds[0];
          this.createLaunchPadObject();

          this.updateOffer.offerId = this.resObj.offerId;
          this.updateOffer.doj = this.date_;
          this.updateOffer.location = this.cityId[0].key;
          this.updateOffer.puCode = this.resObj.puCode;
          this.updateOffer.applicationId = aid;
          // if (this.resObj.indentId != null) {
          //   this.openIndentBpm()
          //   this.blockIndentBpm()
          // }
          this.activityService.updateOfferDetails(this.updateOffer).subscribe(
            () => {
              this.activityService.updateLaunchPad(this.launchPad).subscribe(
                () => {
                  this.ngxLoader.stop();
                },
                (_err) => {
                  this.ngxLoader.stop();
                  this.__warningER.next('Some Error Occured');
                },
              );
              this.childEvent.emit();
              this._successER.next('Updated Succesfully');
            },
            (_err) => {
              this.ngxLoader.stop();
              this.__warningER.next('Some Error Occured');
            },
          );
        }
      },
      (_err) => {
        this.ngxLoader.stop();
        const data1 = {
          msg: 'Some error occurred',
          isSuccess: false,
        };
        this.activityService.openSnackBar(data1, 'danger-snack');
      },
    );
  }

  changeDojCategory(dojRes) {
    if (dojRes == this.doj_reason) {
      this.dojReasonChanged = false;
    } else {
      this.dojReasonChanged = true;
    }
    if (dojRes.key == 640) {
      this.enableReason = true;
    } else {
      this.enableReason = false;
    }
    this.enableButton();
  }

  attachmentChk() {
    if (this.fileData) {
      const te = this.fileData.map((file) => {
        return file.attachmentId;
      });
      if (!te.includes(111) && !te.includes(141)) {
        this.ngxLoader.stop();
        this.activityService.openSnackBar(
          { msg: 'Please upload Service operational head and TA head approval attachments', isSuccess: false },
          'danger-snack',
        );
        this.enableButton();
      } else if (!te.includes(111)) {
        this.ngxLoader.stop();
        this.activityService.openSnackBar(
          { msg: 'Please upload Service operational head approval attachments', isSuccess: false },
          'danger-snack',
        );
        this.enableButton();
      } else if (!te.includes(141)) {
        this.ngxLoader.stop();
        this.activityService.openSnackBar(
          { msg: 'Please upload TA head approval attachments', isSuccess: false },
          'danger-snack',
        );
        this.enableButton();
      } else {
        if (this.companyHiringType == 1 || this.companyHiringType == 4) {
          this.dojUanEhc();
        } else if (this.compHiringType == 9) {
          this.runType9Flow();
        } else {
          this.updateWrapper();
        }
      }
    } else {
      this.ngxLoader.stop();
      this.activityService.openSnackBar(
        { msg: 'Please upload Service operational head and TA head approval attachments', isSuccess: false },
        'danger-snack',
      );
    }
    this.enableButton();
  }

  createLaunchPadObject() {
    let loc;
    for (const act of this.activitiesExecuted) {
      if (act.activityDescription == 'Offer Accepted') {
        loc = true;
        break;
      }
    }
    if (loc == true) {
      this.launchPad.candidate[0].offerStatus = 'Offer Accepted';
    } else {
      this.launchPad.candidate[0].offerStatus = 'Offer Released';
    }
    console.log('this.launchPad.candidate[0].offerStatus ', this.launchPad.candidate[0].offerStatus);

    this.launchPad.candidate[0].candidateId = this.candidateId;
    this.launchPad.candidate[0].doj = this.date_;
    this.launchPad.candidate[0].posLoc = this.location;
    this.launchPad.candidate[0].unit = this.pu_Code;
    this.launchPad.candidate[0].activityId = this.checkSuitabilityDataObj.activityId;
    console.log(this.launchPad);
  }
  async getAllDocuments() {
    await this.getSpclBns();
    this.ngxLoader.stop();
  }
  async getSpclBns() {
    try {
      const spclTmplt = await this.activityService.getSpclBns(637).toPromise();
      const clauseArr = spclTmplt[0];
      this.information_bonus_sheet = [...this.information_bonus_sheet, clauseArr];
    } catch (err) {
      console.log(err);
    }
  }
  generateSpclDoc(spclBns) {
    return new Promise((_resolve, _reject) => {
      if (spclBns) {
        let title = 'Mr';
        if (this.candidateSelected.gender == 'F' || this.candidateSelected.gender == '2') {
          title = 'Ms';
        }
        this.jb_service.fname = this.selectedCand[0].firstName;
        this.jb_service.lname = this.selectedCand[0].lastName;
        this.jb_service.joining_bonus = this.joiningBonus;
        this.jb_service.special_bonus = this.specialBonus;
        this.jb_service.Title = title;
        this.jb_service.PresentAddressLine1 = this.addressForBonus;
        this.jb_service.offerLetterDate = this.resObj.released_date;
        this.jb_service.doj = this.datepipe.transform(this.date_, 'MMMM dd, yyyy');
        if (this.addressForBonus.address1) {
          this.jb_service.generateSpclBns(spclBns).then(async (_spclBnsSheet) => {
            this.sIB = this.jb_service.siB;
            this.joiningBonusCoverletter();
          });
        }
      }
    });
  }
  generateJnslDoc(spclBns) {
    return new Promise((_resolve, _reject) => {
      if (spclBns) {
        let title = 'Mr';
        if (this.candidateSelected.gender == 'F' || this.candidateSelected.gender == '2') {
          title = 'Ms';
        }
        this.jb_service.fname = this.selectedCand[0].firstName;
        this.jb_service.lname = this.selectedCand[0].lastName;
        this.jb_service.joining_bonus = this.joiningBonus;
        this.jb_service.special_bonus = this.specialBonus;
        this.jb_service.Title = title;
        this.jb_service.candidateId = this.candidateSelected.candidateId;
        this.jb_service.PresentAddressLine1 = this.addressForBonus;
        this.jb_service.offerLetterDate = this.resObj.released_date;
        this.jb_service.doj = this.datepipe.transform(this.date_, 'MMMM dd, yyyy');
        if (this.addressForBonus.address1) {
          this.jb_service.generateJnslBns(spclBns).then(async (JnsBnsSheet) => {
            console.log(JnsBnsSheet, 'spclBnsSheet');
            this.sIB = this.jb_service.siB;
            this.joiningBonusCoverletter();
          });
        }
      }
    });
  }
  onAccountNameInputChange(event: any) {
    const value = event.target.value;
    this.accountName = value;
    const validOption = this.accountNameOptions.find((x) => x.value === value);
    this.invalidAccountName = !validOption || !!value;
    this.changedAccName = validOption ? value !== this.chkAccountName : false;
    if (!value || value.trim() === '') {
      this.changedAccName = false;
      this.filteredAccountNames = [];
      this.enableButton();
      return;
    }
    this.changedAccName = value !== this.chkAccountName;
    if (value?.length >= 2) {
      const enterdValue = value.toLowerCase();
      const exactMatch = this.accountNameOptions.find((x) => x.value.toLowerCase() === enterdValue);
      const partialMatch = this.accountNameOptions.filter(
        (p) => p.value.toLowerCase().includes(enterdValue) && p.value.toLowerCase() !== enterdValue,
      );
      this.filteredAccountNames = exactMatch ? [exactMatch, ...partialMatch] : partialMatch;
    } else {
      this.filteredAccountNames = [];
    }
    this.enableButton();
  }

  onAccountNameSelected(event: any) {
    this.accountName = event.option.value;
    this.changedAccName = this.accountName !== this.chkAccountName;
    this.invalidAccountName = false;
    this.enableButton();
  }

  loadAdditionalFieldsAndValues() {
    const screenName = 'Lateral Offer';
    this.activityService.getGenModelLateralStructure(this.candidateApplicationIds, screenName).subscribe((res) => {
      if (!res || !res.fields) {
        return;
      }
      const accName = res.fields.find((f) => f.name === 'additionalAddendum');
      if (!accName) {
        return;
      }
      this.accountNameOptions = accName.options;
      // const hiringTypeCategory = res.fields.find(f => f.name === 'Hiring_Type_Category');
      // this.hiringTypeCategoryOptions = hiringTypeCategory.options;
      this.activityService.getCandidateOfferUpdate(this.candidateApplicationIds[0]).subscribe((dataFetched) => {
        this.resObj = dataFetched;
        // this.hiringTypeCategory = this.resObj.hiringTypeCategory || '';
        // this.chkHiringTypeCategory = this.hiringTypeCategory;
        const accountNameObj = this.accountNameOptions.find((x) => x.value === this.resObj.accountname);
        this.accountName = accountNameObj ? accountNameObj.value : null;
        this.chkAccountName = this.accountName;
        this.filteredAccountNames = [];
      });
    });
  }

  // onHiringTypeCategoryChange(val: any) {
  //   this.changedHiringTypeCategory = val !== this.chkHiringTypeCategory;
  //   this.enableButton();
  // }

  onRemarksChange(value: string) {
    if (this.compHiringType == 1) {
      this.remarksChanged = value !== this.chkRemarks;
    }
    this.enableButton();
  }

  isUpdateDisabled(): boolean {
    if (this.compHiringType == 9) {
      return this.updateOfferFormRef?.invalid || this.attachmentId != 280 || this.dojError || !this.changedDoj;
    }
    return (
      this.updateOfferFormRef?.invalid ||
      this.invalidAccountName ||
      (!this.enableBtn && !this.joiningBonus_button && !this.specialBonus_button) ||
      (this.offerValidationExpired && (!this.dojApproverMailId || this.attachmentId != 268)) ||
      this.dojError ||
      (this.compHiringType == 4 && this.add_jb && this.joiningBns.invalid)
    );
  }

  fetchJoiningAddress(cityId: number, estType: string) {
    this.activityService.addressUrl(cityId, estType).subscribe((res: any) => {
      const addressData = res
        .filter((a) => a.establishmentSubtype == estType && a.cityId == cityId)
        .sort((a, b) => a.sequenceNumber - b.sequenceNumber);
      const completeAddress = [];
      for (const a of addressData) {
        if (a.flag !== 'F' && !a.defaultEst) {
          completeAddress.push(a.address);
        }
      }
      this.joiningAddress = completeAddress.join(', ');
    });
  }
}
